// Auto-generated by robust sync script
export const migrated = {
  le_lien_de_votre_annonce_airbnb_est_obligatoire_:
    "Απαιτείται ο σύνδεσμος για τη διαφήμισή σας στην Airbnb",
  la_note_airbnb_doit__tre_au_minimum_de_4_5_:
    "Η βαθμολογία Airbnb πρέπει να είναι τουλάχιστον 4 έως 5",
  compte_cr______v_rifiez_votre_email_pour_activer_votre_acc_s_au_club_:
    "Δημιουργία λογαριασμού ελέγξτε το email σας για να ενεργοποιήσετε την πρόσβασή σας στο κλαμπ",
  club_r_serv__aux_h_tes_airbnb_not_s_4_5__:
    "Το κλαμπ προορίζεται για επισκέπτες της airbnb όχι s'4 5",
  comparez_vos_gains_r_els: "Συγκρίνετε τα πραγματικά κέρδη σας",
  le_mod_le_traveltrok_est_gagnant_gagnant___le_voya:
    "Το traveltrok mod είναι νικητής, ο ταξιδιώτης κερδίζει",
  votre_prix_sur_les_autres_sites: "Η τιμή σας σε άλλους ιστότοπους",
  diminuer_le_prix: "Μειώστε την τιμή",
  augmenter_le_prix: "Αυξήστε την τιμή",
  net_pour_vous: "Δίκτυ για εσάς",
  de_commissions: "Επιτροπές",
  prix_pay__par_le_voyageur: "Τιμή πληρώνεται από τον ταξιδιώτη",
  revenu___d_clarer__imp_ts_: "Εισόδημα για δήλωση φόρων",
  vous_d_clarez_100__du_prix____commissions__:
    "Δηλώνετε 100 από τις προμήθειες τιμής",
  de_frais_h_te: "Χρεώσεις φιλοξενίας",
  __0__compar____booking_: "0 σύγκριση κράτησης",
  mod_le_frais_h_te__depuis_25_____:
    "Διαμορφώστε το τέλος φιλοξενίας από τις 25",
  vous_d_clarez_100__du_prix_voyageur_: "Δηλώνετε 100 της τιμής του επιβάτη",
  strat_gie_gagnante: "Στρατηγική νίκης",
  prix_voyageur: "Τιμή ταξιδιού",
  _5__pour_le_voyageur: "5 για τον ταξιδιώτη",
  le_meilleur_des_deux_mondes: "Το καλύτερο και των δύο κόσμων",
  avantage_fiscal: "Φορολογικό πλεονέκτημα",
  vous_d_clarez_moins__vous_payez_moins_d____imp_ts_:
    "Δηλώνετε λιγότερο πληρώνετε λιγότερους φόρους",
  sc_nario___traveltrok_applique_5__de_frais_voyageu:
    "Το Sc nario traveltrok επιβάλλει 5 ταξιδιωτικές χρεώσεις",
  appartement: "Διαμέρισμα",
  maison: "Σπίτι",
  inclut_villa_chalet: "Περιλαμβάνει βίλα σαλέ",
  loft: "Πατάρι",
  luxe: "Πολυτέλεια",
  insolite: "Ασυνήθης",
  autre: "Αλλος",
  campagne: "Εκστρατεία",
  mer: "Θάλασσα",
  montagne: "Βουνό",
  au_dessus_de_500_nuit: "Πάνω από 500€/διανυκτέρευση",
  aucun_resultat_dynamique: "Δεν υπάρχουν δυναμικά αποτελέσματα",
  service_de_localisation_indisponible__r_essayez_da:
    "Η υπηρεσία τοποθεσίας δεν είναι διαθέσιμη, δοκιμάστε ξανά σε λίγο",
  quel_type_de_logement_souhaitez_vou:
    "Τι είδους κατάλυμα θέλετε να προσφέρετε;",
  choisissez_la_cat_gorie_qui_d_crit_le_mieux_votre_:
    "Επιλέξτε την κατηγορία που περιγράφει καλύτερα τη διαμονή σας",
  quel_est_le_cadre_du_logement__: "Πώς είναι το οικιστικό περιβάλλον;",
  o__est_situ__votre_logement__: "Πού βρίσκεται το κατάλυμά σας;",
  pays_europ_en_de_r_f_rence: "Ευρωπαϊκή χώρα αναφοράς",
  ville__village__code_postal___: "Πόλη, χωριό, ταχυδρομικός κώδικας...",
  recherche_en_cours___: "Έρευνα σε εξέλιξη...",
  recherche___: "Ερευνα...",
  localiser: "Εγκατάσταση",
  nous_utiliserons_cette_adresse_pour_localiser_votr:
    "Θα χρησιμοποιήσουμε αυτή τη διεύθυνση για να εντοπίσουμε το κατάλυμά σας",
  localis_: "Τοπική",
  _copy__openstreetmap_france: "© OpenStreetMap Γαλλία",
  emplacement_valid_: "Επικυρωμένη τοποθεσία",
  d_crivez_votre_logement: "Περιγράψτε τη διαμονή σας",
  donnez_envie_aux_voyageurs_de_s_journer_chez_vous_:
    "Κάντε τους ταξιδιώτες να θέλουν να μείνουν μαζί σας",
  titre_de_l__annonce: "Τίτλος διαφήμισης",
  ex__charmant_studio_au_c_ur_de_paris:
    "Π.χ.: Γοητευτικό στούντιο στην καρδιά του Παρισιού",
  soyez_concis_et_accrocheur: "Να είστε συνοπτικοί και πιασάρικοι",
  description_d_taill_e: "Αναλυτική περιγραφή",
  parlez_de_votre_logement__du_quartier__des__quipem:
    "Μιλήστε για τη διαμονή σας, τη γειτονιά, τις ανέσεις...",
  mentionnez_les_points_forts: "Αναφέρετε τα δυνατά σημεία",
  voyageurs: "Ταξιδιώτες",
  chambres: "Δωμάτια",
  lits: "Κρεβάτια",
  salles_de_bain: "Μπάνια",
  d_tails_du_logement: "Στοιχεία διαμονής",
  donnez_plus_d__informations_sur_la_capacit__d__acc:
    "Δώστε περισσότερες πληροφορίες σχετικά με την ικανότητα υποδοχής",
  surface__m__: "Έκταση (m²)",
  ex__85: "Π.χ.: 85",
  ajoutez_des_photos: "Προσθήκη φωτογραφιών",
  mettez_en_valeur_votre_logement_avec_de_belles_ima:
    "Αναδείξτε το σπίτι σας με όμορφες εικόνες",
  glissez_vos_photos_ici: "Σύρετε τις φωτογραφίες σας εδώ",
  parcourez_vos_fichiers: "Περιηγηθείτε στα αρχεία σας",
  jpg__png_jusqu____5_mo: "JPG, PNG (έως 5 MB)",
  d_j__en_ligne: "Ήδη online",
  __uploader: "Για να ανεβάσετε",
  fixez_votre_prix: "Ορίστε την τιμή σας",
  vous_pourrez_le_modifier___tout_moment_:
    "Μπορείτε να το τροποποιήσετε ανά πάσα στιγμή",
  par_nuit: "Ανά νύχτα",
  aper_u_de_votre_annonce: "Προεπισκόπηση της διαφήμισής σας",
  titre_de_votre_annonce: "Ο τίτλος της διαφήμισής σας",
  nouveau: "Νέος",
  localisation: "Τοποθεσία",
  suppression_du_profil__tapez_supprimer_puis_confirmez__si_la_suppression_compl_te_est_impossible__votre_profil_sera_mis_en_pause_et_masque_:
    "Διαγράφοντας τον τύπο προφίλ διαγραφή και, στη συνέχεια, επιβεβαιώστε εάν η πλήρης διαγραφή είναι αδύνατη, το προφίλ σας θα τεθεί σε παύση και θα κρυφτεί",
  suppression_compl_te_indisponible__profil_mis_en_pause_et_masque_:
    "Ολοκληρώστε τη διαγραφή μη διαθέσιμου προφίλ σε παύση και απόκρυψη",
  preferences: "Προτιμήσεις",
  gerez_vos_unites__votre_visibilite_et_le_statut_de_votre_profil_:
    "Διαχειριστείτε τις μονάδες σας, την ορατότητά σας και την κατάσταση του προφίλ σας",
  vous_restez_connecte_mais_vos_annonces_ne_sont_plus_actives_dans_les_suggestions_:
    "Παραμένετε συνδεδεμένοι, αλλά οι διαφημίσεις σας δεν είναι πλέον ενεργές στις προτάσεις",
  votre_profil_et_vos_logements_ne_remontent_plus_dans_la_carte_et_les_pages_de_destinations_:
    "Το προφίλ σας και τα καταλύματα σας δεν εμφανίζονται πλέον στις σελίδες χάρτη και προορισμού",
  base_de_donnees_non_migree__vos_preferences_sont_sauvegardees_localement_pour_l_instant_:
    "Η βάση δεδομένων δεν μετεγκαταστάθηκε, οι προτιμήσεις σας αποθηκεύονται τοπικά προς το παρόν",
  delai_depasse: "Η προθεσμία υπερβαίνει",
  echeance_aujourd__hui: "Λήγει σήμερα",
  mois_restants: "Μήνες που απομένουν",
  nuits_dues_et_aucun_accueil_effectue:
    "Οφειλόμενες νύχτες και δεν πραγματοποιήθηκε δεξίωση",
  suivi_des_echanges: "Παρακολούθηση ανταλλαγών",
  suivez_les_nuits_dues_dans_les_deux_sens__qui_vous_doit_des_nuits__qui_vous_devez_accueillir__et_le_temps_restant_pour_cl__turer_chaque_echange_:
    "Παρακολουθήστε τις οφειλόμενες νύχτες και με τους δύο τρόπους ποιος σας χρωστάει νύχτες που οφείλετε και τον χρόνο που απομένει για να κλείσετε κάθε ανταλλαγή",
  nom__logement__contrat__dates__statut_des_deux_c_tes_et_temps_restant_:
    "Ονομασία ημερομηνίας σύμβασης διαμονής κατάσταση και των δύο πλευρών και χρόνος που απομένει",
  visualisez_vos_villes_cibles_et_les_rayons_de_recherche_autour_de_chaque_point_:
    "Οραματιστείτε τις πόλεις-στόχους σας και τις ακτίνες αναζήτησης γύρω από κάθε σημείο",
  __d_couvrir___: "να καλύψει",
  les_incontournables___visiter_lors_de_votre_s_jour:
    "Τα βασικά μέρη που πρέπει να επισκεφτείτε κατά τη διαμονή σας",
  impossible_de_finaliser_la_demande__r_essaie_dans_:
    "Δεν είναι δυνατή η οριστικοποίηση του αιτήματος, δοκιμάστε ξανά",
  r_server_ton_s_jour___: "κλείστε τη διαμονή σας",
  parcours_simple_en_3__tapes__recherche__d_tails__v:
    "Απλή αναζήτηση 3 βημάτων για λεπτομέρειες v",
  recherche: "Ερευνα",
  validation: "Νομιμοποίηση",
  demande_envoy_e: "Το αίτημα εστάλη",
  un_h_te_va_te_r_pondre_rapidement_avec_les_d_tails:
    "Ένας οικοδεσπότης θα απαντήσει γρήγορα με λεπτομέρειες",
  cr_er_une_nouvelle_demande: "δημιουργήστε ένα νέο αίτημα",
  "1__ton_s_jour": "1 ημέρα",
  arriv_e: "Αφιξη",
  pers_: "Ανθρωποι",
  dates_flexibles: "Ευέλικτες ημερομηνίες",
  dates_exactes: "Ακριβείς ημερομηνίες",
  _3_jours: "3 μέρες",
  _7_jours: "7 μέρες",
  _14_jours: "14 ημέρες",
  je_voyage_avec_des_animaux: "Ταξιδεύω με ζώα",
  "2__infos_r_servation": "2 πληροφορίες κρατήσεων",
  nom_complet: "Ονοματεπώνυμο",
  ex__clara_martin: "ex clara martin",
  message___l_h_te: "Στείλτε μήνυμα στον οικοδεσπότη",
  pr_sentation_rapide__heure_d_arriv_e__besoins_part:
    "Η ώρα άφιξης της γρήγορης παρουσίασης χρειάζεται μέρος",
  "3__validation_de_la_r_servation": "3 επικύρωση της κράτησης",
  destination: "Προορισμός",
  s_jour: "διαμονή",
  flexibilit_: "Ευκαμψία",
  tarification_traveltrok: "τιμολόγηση traveltrok",
  frais_plateforme: "Τέλη πλατφόρμας",
  "1eur_voyageur___1eur_h_te": "1 ο ταξιδιώτης τους 1 ο οικοδεσπότης τους",
  incluse: "Συμπεριλαμβανομένος",
  total_estim_: "Συνολική εκτίμηση",
  continuer: "Συνεχίζω",
  envoi___: "Αποστολή",
  confirmer_ma_r_servation: "Επιβεβαιώστε την κράτησή μου",
  r_sum__intelligent: "R άθροισμα έξυπνο",
  prix_base: "Τιμή βάσης",
  total_actuel: "Τρέχον σύνολο",
  inclut_1eur_voyageur___1eur_h_te_par_nuit__assuran:
    "Περιλαμβάνει 1 επισκέπτη και 1 επισκέπτη ανά διανυκτέρευση",
  membres_actifs: "Ενεργά μέλη",
  note_moyenne: "Μέση βαθμολογία",
  d_couvrez_: "ανακαλύπτω",
  points_forts: "Ανταύγειες",
  conseils_pratiques: "Πρακτικές συμβουλές",
  informations_pratiques: "Πρακτικές πληροφορίες",
  meilleure_saison: "Καλύτερη σεζόν",
  s_jour_moyen: "μέση διαμονή",
  langue: "Γλώσσα",
  monnaie: "Μετρητά",
  fuseau_horaire: "Ζώνη ώρας",
  voir_les_logements: "Δείτε τα καταλύματα",
  nous_contacter: "Επικοινωνήστε μαζί μας",
  villa: "Βίλα",
  logements_disponibles___: "Διαθέσιμα καταλύματα",
  annonces___la_nuit_avec_h_tes_v_rifi_s_:
    "Διανυκτερεύσεις με επαληθευμένους οικοδεσπότες",
  voir_la_carte_des_logements: "Δείτε τον χάρτη διαμονής",
  h_te_v_rifi_: "επαληθευμένος κεντρικός υπολογιστής",
  mod_le_traveltrok: "Mod the traveltrok",
  r_server: "να κάνετε κράτηση",
  pas_encore_de_logements_ici: "Δεν υπάρχει ακόμη κατάλυμα εδώ",
  sois_le_premier_h_te___proposer_son_logement___:
    "Γίνετε ο πρώτος οικοδεσπότης που θα προσφέρει τη διαμονή του",
  ajouter_mon_logement: "Προσθέστε τη διαμονή μου",
  destinations_proches: "Κοντινοί προορισμοί",
  explorez_d_autres_destinations_en_: "Εξερευνήστε άλλους προορισμούς σε",
  am_rique_du_nord: "Βόρεια Αμερική",
  am_rique_du_sud: "Νότια Αμερική",
  oc_anie: "Ωκεανία",
  afrique: "Αφρική",
  asie: "Ασία",
  europe: "Ευρώπη",
  carte_des_destinations: "Χάρτης προορισμού",
  destinations_affich_es: "Εμφανιζόμενοι προορισμοί",
  continents: "ηπείρους",
  survolez_un_point_pour_voir_les_d_tails:
    "Τοποθετήστε το δείκτη του ποντικιού πάνω από ένα σημείο για να δείτε λεπτομέρειες",
  _changes_r_alis_s: "αλλαγές που έγιναν",
  mes_favoris: "Τα αγαπημένα μου",
  sauvegard_: "Εφεδρικός",
  tout_effacer: "Καθαρίστε όλα",
  s_lectionn_: "Επιλογή",
  pour_comparaison: "Για σύγκριση",
  voir_la_comparaison: "Δείτε τη σύγκριση",
  trier_par__: "ταξινόμηση κατά",
  note: "Σημείωμα",
  _changes: "αλλαγές",
  capacit_: "Ικανότητα",
  pi_ces: "Κομμάτια",
  type_de_logement: "Τύπος καταλύματος",
  effacer: "Να σβήσει",
  r_initialiser_les_filtres: "R αρχικοποίηση φίλτρων",
  filtres_actifs__: "Ενεργά φίλτρα",
  aucun_r_sultat: "Κανένα αποτέλεσμα",
  aucun_favori_ne_correspond___vos_filtres_:
    "Κανένα αγαπημένο δεν ταιριάζει με τα φίλτρα σας",
  comparaison_des_logements: "Σύγκριση καταλυμάτων",
  logements_s_lectionn_s: "Επιλεγμένα καταλύματα",
  fermer: "Κοντά",
  astuce: "Τέχνασμα",
  utilisez_les_filtres_pour_affiner_vos_favoris_par:
    "Χρησιμοποιήστε τα φίλτρα για να βελτιώσετε τα αγαπημένα σας",
  type: "Είδος",
  s_lectionnez_ensuite_jusqu______4_logements_pour_l:
    "Στη συνέχεια επιλέξτε έως και 4 υποδοχές για το",
  aucun_sch_ma_conversation_compatible_trouv__:
    "Δεν βρέθηκε η συμβατή συνομιλία μου",
  souhaite_venir_dynamique: "Μακάρι να έρθεις δυναμικά",
  aimerais_visiter_dynamique: "Θα ήθελα να επισκεφτώ το δυναμικό",
  demande_ignor_e_: "Το αίτημα αγνοήθηκε",
  conversation_introuvable_: "Η συνομιλία δεν βρέθηκε",
  impossible_d_ouvrir_la_discussion_pour_le_moment_:
    "Δεν μπορώ να ανοίξω συζήτηση αυτή τη στιγμή",
  demande_supprim_e_: "Το αίτημα διαγράφηκε",
  bonjour_merci_dynamique: "Γεια σας ευχαριστώ δυναμική",
  demande_supprim_e_avec_un_message_poli_:
    "Το αίτημα διαγράφηκε με ένα ευγενικό μήνυμα",
  impossible_de_supprimer_cette_demande_pour_le_mome:
    "Δεν είναι δυνατή η διαγραφή αυτού του αιτήματος αυτήν τη στιγμή",
  demandes_directes: "Άμεσα αιτήματα",
  matching_auto: "Θέλουν να έρθουν στην περιοχή σας",
  match_r_ciproque: "Ανταπόκριση",
  carte_secteur: "Κάρτα τομέα",
  toutes: "Ολοι",
  lik_es: "Άρεσε",
  en_discussion: "Υπό συζήτηση",
  ignor_es: "Αγνοήθηκε",
  sans_date_pr_cise__juste__change_:
    "Χωρίς συγκεκριμένη ημερομηνία απλώς ανταλλαγή",
  date_pr_cise___dans_les_6_mois: "Συγκεκριμένη ημερομηνία εντός 6 μηνών",
  date_pr_cise___dans_l_ann_e: "Συγκεκριμένη ημερομηνία του έτους",
  flexible: "Εύκαμπτος",
  date_pr_cise: "Συγκεκριμένη ημερομηνία",
  dates_identiques: "Ίδιες ημερομηνίες",
  dates_compatibles: "Συμβατές ημερομηνίες",
  dates_diff_rentes: "Διαφορετικές ημερομηνίες",
  dates_inconnues: "Άγνωστες ημερομηνίες",
  souhaite_venir__: "Επιθυμία να έρθει",
  voir_le_logement_cibl_: "Προβολή καταλυμάτων-στόχων",
  personnes_int_ress_es_par_votre_secteur:
    "Άτομα που ενδιαφέρονται για τον τομέα σας",
  vert___match_r_ciproque_ville___dates:
    "Πράσινος αμοιβαίος αγώνας ημερομηνίες πόλης",
  int_r_t_entrant: "Εισερχόμενοι τόκοι",
  logement_cibl___: "Στοχευμένη στέγαση",
  dates__: "Ημερομηνίες",
  sans_date_pr_cise: "Χωρίς συγκεκριμένη ημερομηνία",
  ouvrir_le_chat: "Ανοίξτε τη συνομιλία",
  pas_encore_de_points_sur_la_carte: "Δεν υπάρχουν σημεία στον χάρτη ακόμα",
  les_membres_qui_veulent_venir_dans_votre_secteur_a:
    "Μέλη που θέλουν να έρθουν στην περιοχή σας για να",
  logement_vis_: "Στοχευμένη διαμονή",
  demande: "Αίτηση",
  message: "Μήνυμα",
  logement_s_: "καταλύματα",
  annonce_indisponible: "Η ανακοίνωση δεν είναι διαθέσιμη",
  jour_s_: "ημέρες)",
  dur_e___d_finir: "Διάρκεια λήξης",
  match_auto: "Αυτόματη αντιστοίχιση",
  r_ciproque: "Αμοιβαίος",
  discuter_dans_la_messagerie: "Συνομιλία σε μηνύματα",
  ignorer_la_demande: "Αγνοήστε το αίτημα",
  ignorer: "Αγνοώ",
  supprimer_avec_message_poli: "Διαγραφή με ευγενικό μήνυμα",
  poli: "Ευγενικός",
  supprimer_sans_message: "Διαγραφή χωρίς μήνυμα",
  suppr_: "Διαγράφω",
  aucune_demande_pour_le_moment: "Δεν υπάρχουν αιτήματα αυτή τη στιγμή",
  le_tableau_est_pr_t__les_demandes_s_afficheront_ic:
    "Ο πίνακας είναι έτοιμος και τα αιτήματα θα εμφανιστούν εδώ",
  surface: "Επιφάνεια",
  voyagez: "Ταξίδι",
  envie_d___changer_avec_: "Θέλετε να αλλάξετε με",
  proposez_un__change_de_logement_et_d_couvrez_:
    "Προτείνετε ανταλλαγή κατοικιών και κάλυψη",
  gratuitement_: "Δωρεάν",
  voir_la_fiche_du_logement: "Δείτε το φύλλο διαμονής",
  carte_des_logements: "Χάρτης κατοικιών",
  r_sultats_visibles: "ορατά αποτελέσματα",
  jour: "Ημέρα",
  s_lectionn_s: "επιλεγμένα s",
  printemps: "Ανοιξη",
  _t_: "t",
  automne: "Φθινόπωρο",
  hiver: "Χειμώνας",
  toute_l__ann_e: "Όλο το χρόνο",
  bonjour_host_dynamic: "Γεια σας δυναμική υποδοχής",
  impossible_de_contacter_cet_h_te____errormessage__:
    "Δεν είναι δυνατή η επικοινωνία με αυτό το μήνυμα σφάλματος κεντρικού υπολογιστή",
  impossible_de_contacter_cet_h_te_pour_le_moment_:
    "Δεν είναι δυνατή η επικοινωνία με αυτόν τον οικοδεσπότη αυτήν τη στιγμή",
  annonce_introuvable_: "Η αγγελία δεν βρέθηκε",
  choisissez_vos_dates_pour_envoyer_la_proposition_:
    "Επιλέξτε τις ημερομηνίες για να στείλετε την πρόταση",
  la_date_de_d_part_doit__tre_post_rieure___la_date_:
    "Η ημερομηνία αναχώρησης πρέπει να είναι μεταγενέστερη από την ημερομηνία άφιξης",
  proposition_d__change_avec_dates_pr_cises:
    "Πρόταση ανταλλαγής με συγκεκριμένες ημερομηνίες",
  __logement_cibl_: "Στοχευμένη στέγαση",
  __ville: "Πόλη",
  __arriv_e_souhait_e: "Επιθυμητή άφιξη",
  __d_part_souhait_: "Επιθυμητή αναχώρηση",
  __dur_e: "Διάρκεια",
  nuit_s_: "Νύχτες",
  __voyageurs: "Ταξιδιώτες",
  je_suis_ouvert_e____une_n_gociation_si_besoin_:
    "Είμαι ανοιχτός σε διαπραγματεύσεις αν χρειαστεί.",
  indiquez_un_nombre_de_nuits_valide_pour_la_proposi:
    "Υποδείξτε έναν έγκυρο αριθμό διανυκτερεύσεων για την πρόταση",
  proposition_d__change_flexible__sans_dates_fix_es_:
    "Ευέλικτη πρόταση ανταλλαγής χωρίς προκαθορισμένες ημερομηνίες",
  __je_propose: "προτείνω",
  __je_demande: "ρωτάω",
  on_valide_les_dates_ensemble_ensuite_selon_nos_dis:
    "Στη συνέχεια, επικυρώνουμε τις ημερομηνίες μαζί ανάλογα με τη διαθεσιμότητά μας.",
  indiquez_un_nombre_de_nuits_valide_:
    "Εισαγάγετε έναν έγκυρο αριθμό διανυκτερεύσεων",
  proposition_d__change__n_importe_quand_dans_l_ann_:
    "Πρόταση ανταλλαγής οποιαδήποτε στιγμή κατά τη διάρκεια του έτους",
  __dur_e_souhait_e: "Επιθυμητή διάρκεια",
  __p_riode_pr_f_r_e: "Προτιμώμενη περίοδος",
  je_suis_flexible_sur_les_dates_exactes_et_pr_t_e__:
    "Είμαι ευέλικτος στις ακριβείς ημερομηνίες και πρόθυμος να μιλήσω για αυτό.",
  proposition_invalide_: "Μη έγκυρη πρόταση",
  proposition_envoy_e__ouverture_de_la_discussion___:
    "Η πρόταση εστάλη, η συζήτηση άνοιξε...",
  impossible_d_envoyer_votre_proposition____errormes:
    "Δεν είναι δυνατή η αποστολή της πρότασής σας",
  impossible_d_envoyer_votre_proposition_pour_le_mom:
    "Δεν είναι δυνατή η αποστολή της πρότασής σας αυτήν τη στιγμή",
  logement_introuvable: "Το κατάλυμα δεν βρέθηκε",
  retour_aux_logements: "Επιστροφή στο κατάλυμα",
  annonce_airbnb: "Διαφήμιση Airbnb",
  lien_airbnb_verification_helper:
    "Αυτός ο σύνδεσμος μας επιτρέπει να επαληθεύσουμε ότι είστε ο διαχειριστής της διαφήμισης.",
  aucune_photo_disponible: "Δεν υπάρχουν διαθέσιμες φωτογραφίες",
  logement_propos__par: "Διαμονή που προσφέρεται από",
  __propos_de_ce_logement: "Σχετικά με αυτό το κατάλυμα",
  aucune_description_fournie_: "Δεν παρέχεται περιγραφή",
  ce_que_propose_ce_logement: "Τι προσφέρει αυτό το κατάλυμα",
  description_du_logement: "Περιγραφή καταλύματος",
  aucun__quipement_sp_cifi__: "Δεν υπάρχει καθορισμένος εξοπλισμός",
  _change_entre_h_tes: "ανταλλαγή μεταξύ των οικοδεσποτών",
  votre_proposition_d__change: "Η πρόταση ανταλλαγής σας",
  quand_vous_voulez: "Όταν θέλεις",
  je_propose: "προτείνω",
  nuits_chez_moi: "Νύχτες στο χώρο μου",
  je_demande: "ρωτάω",
  nuits_chez_vous: "Νύχτες στο χώρο σας",
  nombre_de_nuits: "Αριθμός διανυκτερεύσεων",
  p_riode_pr_f_r_e: "Προτιμώμενη περίοδος",
  message__optionnel_: "Προαιρετικό μήνυμα",
  ex__nous_sommes_flexibles__on_peut_s_adapter___vos:
    "Πρώην είμαστε ευέλικτοι μπορούμε να προσαρμοστούμε στα δικά σας",
  entrer_en_n_gociation: "Μπείτε σε διαπραγμάτευση",
  envoyer_ma_proposition: "Στείλε την πρότασή μου",
  vous_pouvez_proposer_un__change_avec_ou_sans_dates:
    "Μπορείτε να προσφέρετε μια ανταλλαγή με ή χωρίς ημερομηνίες",
  informations_l_gales: "Νομικές πληροφορίες",
  conditions_d____utilisation: "Όροι χρήσης",
  en_utilisant_traveltrok__vous_acceptez_d_utilise:
    "Χρησιμοποιώντας το traveltrok συμφωνείτε να χρησιμοποιήσετε",
  les__changes_se_font_directement_entre_membres__:
    "Οι ανταλλαγές γίνονται απευθείας μεταξύ των μελών",
  traveltrok_peut_suspendre_un_compte_en_cas_de_co:
    "Η DONKEY TRAVEL μπορεί να αναστείλει έναν λογαριασμό σε περίπτωση συν",
  en_rejoignant_traveltrok__vous_acceptez_ces_engagements__la_confiance_se_construit_sur_des_actes_simples__honn_tet___respect_et_parole_tenue_:
    "Με την εγγραφή σας στο DONKEY TRAVEL, αποδέχεστε αυτές τις δεσμεύσεις. Η εμπιστοσύνη βασίζεται σε απλές ενέργειες.",
  cette_charte_est_align_e_avec_les_standards_publics_des_plateformes_majeures__respect_du_logement__fiabilit___anti_f_te__communication__:
    "Μια σταθερή ναύλωση σύμφωνα με τις βέλτιστες πρακτικές άλλων διάσημων εταιρειών.",
  retrait_du_club_en_cas_de_manquement_grave_ou_r_p_tition_:
    "Αποχώρηση από τον σύλλογο μετά από επανάληψη ή σοβαρό παράπτωμα.",
  exclusion_d_finitive: "Μόνιμος αποκλεισμός",
  compte_limit__le_temps_de_v_rifier_les_faits_et_prot_ger_la_communaut__:
    "Περιορισμένος λογαριασμός σε αναμονή γεγονότων.",
  suspension_temporaire: "Προσωρινή αναστολή",
  rappel__crit_des_r_gles__avec_demande_de_correction_imm_diate_:
    "Υπενθύμιση των κανόνων και απαιτούμενη διόρθωση.",
  avertissement_officiel: "Επίσημη προειδοποίηση",
  le_club_prot_ge_les_h_tes_fiables__les_manquements_r_p_t_s_ou_graves_entra_nent_des_mesures_imm_diates_:
    "Το κλαμπ προστατεύει αξιόπιστους επισκέπτες. Σοβαρές παραβιάσεις οδηγούν σε δράση.",
  toute_annulation_doit__tre_document_e_dans_la_messagerie_et_trait_e_par_le_support_:
    "Οποιαδήποτε ακύρωση πρέπει να τεκμηριώνεται σε μηνύματα και να υποβάλλεται σε επεξεργασία από την υποστήριξη.",
  on_n_annule_pas_un__change_sans_raison_valable__en_cas_de_force_majeure__sinistre__maladie_grave__impossibilit__l_gale___un_report_doit__tre_propos__au_plus_vite_:
    "Δεν ακυρώνουμε μια ανταλλαγή χωρίς βάσιμο λόγο. Σε περίπτωση ανωτέρας βίας (καταστροφή, σοβαρή ασθένεια, νομική αδυναμία), πρέπει να προταθεί αναβολή το συντομότερο δυνατό.",
  je_communique_vite_en_cas_de_doute_ou_de_changement_:
    "Επικοινωνώ γρήγορα σε περίπτωση αμφιβολίας ή αλλαγής.",
  j_accueille_quelqu_un_qui_exerce_le_m_me_m_tier_d_h_te_:
    "Καλωσορίζω κάποιον που κάνει την ίδια δουλειά ως οικοδεσπότης.",
  j_assure_un_accueil_chaleureux_et_professionnel_:
    "Παρέχω ένα θερμό και επαγγελματικό καλωσόρισμα.",
  relation_entre_h_tes: "Σχέση μεταξύ οικοδεσποτών",
  les__ventuels_frais_de_m_nage_sont_annonc_s_et_valid_s_avant_s_jour_:
    "Τυχόν χρεώσεις καθαρισμού ανακοινώνονται και επικυρώνονται πριν από την ανταλλαγή.",
  les_informations_d_acc_s_et_de_fonctionnement_sont_claires_:
    "Οι πληροφορίες πρόσβασης και λειτουργίας είναι σαφείς.",
  linge_et_pr_paration: "Πλύσιμο και προετοιμασία",
  le_niveau_de_prestation_reste_identique__m_me_en__change_gratuit_:
    "Το επίπεδο εξυπηρέτησης παραμένει το ίδιο, ακόμη και σε δωρεάν ανταλλαγή.",
  le_logement_est_propre_et_pr_t___vivre_d_s_l_arriv_e_:
    "Το κατάλυμα είναι καθαρό και έτοιμο για διαμονή κατά την άφιξη.",
  je_pr_pare_le_logement_comme_pour_un_client_airbnb_:
    "Ετοιμάζω τη διαμονή ως πελάτη της Airbnb.",
  qualit__d_accueil__quivalente: "Αντίστοιχη ποιότητα υποδοχής",
  je_respecte_le_calme__les_voisins_et_le_quartier_:
    "Σέβομαι την ηρεμία, τους γείτονες και τη γειτονιά.",
  aucune_f_te___v_nement_ou_invitation_non_autoris_e_dans_le_logement_:
    "Δεν επιτρέπονται πάρτι, εκδηλώσεις ή μη εξουσιοδοτημένες προσκλήσεις στο κατάλυμα.",
  je_respecte_le_r_glement_int_rieur_de_l_h_te_:
    "Σέβομαι τους εσωτερικούς κανονισμούς του οικοδεσπότη.",
  vie_de_quartier_et_r_gles: "Η ζωή και οι κανόνες της γειτονιάς",
  quand_des_dates_sont_bloqu_es__je_m_engage___venir_:
    "Όταν μπλοκάρονται οι ημερομηνίες, δεσμεύομαι να έρθω.",
  je_ne_mens_pas_sur_la_valeur_prix_habituel_de_mon_logement_:
    "Δεν λέω ψέματα για τη συνήθη τιμή τιμής του καταλύματός μου.",
  je_ne_mens_pas_sur_ma_fiche__mon_historique_ni_mon_logement_:
    "Δεν λέω ψέματα στο προφίλ μου, στο ιστορικό μου ή στο κατάλυμα μου.",
  honn_tet__et_fiabilit_: "Ειλικρίνεια και αξιοπιστία",
  je_respecte_le_mat_riel__les__quipements_et_les_consignes_de_d_part_:
    "Σέβομαι τα υλικά, τον εξοπλισμό και τις οδηγίες αναχώρησης.",
  je_range_le_linge_utilis___ex__draps_en_boule___l_endroit_indiqu___pour_limiter_les_frais_de_m_nage_:
    "Αποθηκεύω μεταχειρισμένα λευκά είδη (π.χ. σεντόνια σε μπάλα) στον υποδεικνυόμενο χώρο, για να περιορίσω το κόστος καθαρισμού.",
  je_rends_le_logement_aussi_propre_que_je_l_ai_trouv_:
    "Κάνω το κατάλυμα τόσο καθαρό όσο το βρήκα.",
  respect_total_du_logement: "Απόλυτος σεβασμός για τη στέγαση",
  traveltrok_est_un_club_d_h_tes_s_rieux__une_bonne_note_implique_une_conduite_exemplaire__en_tant_que_voyageur_comme_en_tant_qu_h_te_:
    "Το DONKEY TRAVEL είναι ένα σοβαρό κλαμπ υποδοχής. μια καλή βαθμολογία συνεπάγεται υποδειγματική συμπεριφορά, τόσο ως ταξιδιώτης όσο και ως οικοδεσπότης.",
  "howItWorks.cta.explore": "Εξερευνήστε προορισμούς",
  "howItWorks.cta.signup": "Δείτε τις προσφορές μας",
  "howItWorks.cta.subtitle":
    "Ξεκινήστε νοικιάζοντας το δικό σας χώρο. Στη συνέχεια, ενεργοποιήστε το ανταλλαγή εάν θέλετε να κάνετε ανταλλαγή μεταξύ κεντρικών υπολογιστών.",
  "howItWorks.cta.title": "Είστε έτοιμοι να ξεκινήσετε τις ενοικιάσεις σας;",
  publiez_votre_logement__validez_votre_profil_et_commencez_a_recevoir_des_propositions_d_echange_:
    "Δημοσιεύστε το κατάλυμα σας, επικυρώστε το προφίλ σας και αρχίστε να λαμβάνετε προσφορές ανταλλαγής.",
  visualisez_la_densite_des_logements_deja_inscrits_dans_le_club__les_points_restent_anonymes__pas_d_adresse__pas_de_detail__juste_la_dynamique_du_reseau_:
    "Δείτε την πυκνότητα των κατοικιών που έχουν ήδη εγγραφεί στο κλαμπ. Τα σημεία παραμένουν ανώνυμα (χωρίς διεύθυνση, χωρίς λεπτομέρειες, μόνο δυναμική δικτύου).",
  prenez_du_recul_pour__viter_l__puisement_li___l_accueil_continu_:
    "Κάντε ένα βήμα πίσω για να αποφύγετε την εξάντληση από τη συνεχή φιλοξενία.",
  _an: "/ έτος",
  traveltrok_connecte_les_h_tes_du_monde_entier_pour_des_s_jours_authentiques_et_abordables_:
    "Το DONKEY TRAVEL συνδέει επισκέπτες σε όλο τον κόσμο για αυθεντικές και προσιτές διαμονές.",
  ____100__made_in_france__picardie_: "🇫🇷 100% Made in France (Picardie)",
  pas_la_silicon_valley__mais_la_vall_e_de_la_haute_somme_:
    "Όχι η Silicon Valley, αλλά η κοιλάδα Haute-Somme.",
  _changes_dans_toute_l_europe_entre_h_tes_airbnb_not_s_4_5___offre_lancement_2026___50__:
    "Ανταλλαγές σε όλη την Ευρώπη μεταξύ οικοδεσποτών Airbnb με βαθμολογία 4,5+. Προσφορά κυκλοφορίας 2026: -50%.",
  apr_s_des_mois_d_accueil__transformez_vos_p_riodes_creuses_en_vraies_respirations_sans_exploser_votre_budget_:
    "Μετά από μήνες φιλοξενίας, μετατρέψτε τις αργές περιόδους σας σε πραγματικό χώρο αναπνοής χωρίς να πλήξετε τον προϋπολογισμό σας.",
  prenez_du_recul_pour__viter_l__puisement_li____l_accueil_continu_:
    "Κάντε ένα βήμα πίσω για να αποφύγετε την εξάντληση από τη συνεχή φιλοξενία.",
  accueillez_des_h_tes_qui_connaissent_d_j__les_exigences_du_terrain__puis_partagez_vos_m_thodes_et_vos_retours_d_exp_rience_:
    "Καλωσορίστε επισκέπτες που γνωρίζουν ήδη τις απαιτήσεις του πεδίου και, στη συνέχεια, μοιραστείτε τις μεθόδους και τα σχόλιά σας.",
  voyagez___co_t_r_duit_gr_ce_aux__changes_entre_membres_du_club_:
    "Ταξιδέψτε με μειωμένο κόστος χάρη στις ανταλλαγές μεταξύ των μελών του κλαμπ.",
  quand_votre_quota_local_est_atteint__vous_pouvez__changer_hors_plateforme_sous_r_serve_de_conformit__locale_:
    "Όταν συμπληρωθεί το τοπικό σας όριο, μπορείτε να κάνετε συναλλαγές εκτός πλατφόρμας με την επιφύλαξη τοπικής συμμόρφωσης.",
  traveltrok_est_une_r_volution_europ_enne__une_plateforme_d__changes_pour_les_h_tes_qui_paient_d_j__chauffage__taxes__imp_ts___lectricit___internet_et_entretien__et_accueillent_toute_l_ann_e_comme___l_h_tel__ici__vous__changez_avec_des_h_tes_qui_savent_accueillir__vous_partagez_vos_exp_riences__puis_vous_partez_d_couvrir_un_autre_endroit_sans_vous_ruiner_:
    "Το DONKEY TRAVEL είναι μια ευρωπαϊκή επανάσταση: μια πλατφόρμα ανταλλαγής για επισκέπτες που ήδη πληρώνουν για θέρμανση, φόρους, ηλεκτρισμό, internet και συντήρηση και καλωσορίζουν όλο το χρόνο σαν σε ξενοδοχείο. Εδώ, αλληλεπιδράτε με οικοδεσπότες που ξέρουν πώς να σας καλωσορίζουν, μοιράζεστε τις εμπειρίες σας, μετά πηγαίνετε και ανακαλύπτετε ένα άλλο μέρος χωρίς να ξοδέψετε τα χρήματα.",
  ___notre_mod_le_repose_uniquement_sur_les_abonnements__pas_sur_l_exploitation_des_donn_es_:
    "👉 Το μοντέλο μας βασίζεται αποκλειστικά στις συνδρομές και όχι στην εκμετάλλευση δεδομένων.",
  ___sans_publicit___sans_revente_de_donn_es__100___financ__par_les_membres_:
    "🔒 Χωρίς διαφημίσεις. Χωρίς μεταπώληση δεδομένων. 100% χρηματοδοτείται από τα μέλη.",
  le_club_n_est_pas_un_conseil_juridique___chaque_membre_doit_respecter_les_r_gles_locales__d_clarations__quotas__copropri_t___fiscalit___etc___:
    "Ο σύλλογος δεν παρέχει νομικές συμβουλές. κάθε μέλος πρέπει να σέβεται τους τοπικούς κανόνες (δηλώσεις, ποσοστώσεις, συνιδιοκτησία, φορολογία κ.λπ.).",
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_h_tes_airbnb:
    "Μια ευρωπαϊκή πλατφόρμα ανταλλαγής που προορίζεται για οικοδεσπότες της Airbnb",
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_unique_pour__changer_dans_toute_l_europe_:
    "Ιδιωτικό κλαμπ για επισκέπτες με βαθμολογία 4,5+: μια μοναδική συνδρομή για ανταλλαγή σε όλη την Ευρώπη.",
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_ou__gale___4_5_:
    "Κρατήθηκε για οικοδεσπότες Airbnb με βαθμολογία μεγαλύτερη ή ίση με 4,5.",
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eur_an__prix_garanti___vie_pour_les_1000_premiers_inscrits_:
    "Μείωση 50% το 2026: 25 ευρώ/έτος αντί για 50 ευρώ/έτος. Τιμή εγγυημένη εφ' όρου ζωής για τις πρώτες 1000 εγγραφές.",
  basse_saison__pause__rencontres_entre_h_tes___conomies_vacances__tout_est_pens__pour_les_h_tes_actifs_en_europe_:
    "Χαμηλή περίοδος, διαλείμματα, συναντήσεις μεταξύ επισκεπτών, εξοικονόμηση πόρων για διακοπές: όλα είναι σχεδιασμένα για ενεργούς επισκέπτες στην Ευρώπη.",
  accueillez_des_membres_et_faites_vous_accueillir_en_retour__un__change_simple__direct_et_sans_argent_entre_propri_taires_:
    "Καλώς ήρθατε στα μέλη και σας καλωσορίζουμε ξανά. Μια απλή, άμεση και χωρίς μετρητά ανταλλαγή μεταξύ των ιδιοκτητών.",
  _nous_avons__chang__notre_maison___lyon_contre_une_villa_en_corse__co_t___0___:
    '"Αναλλάξαμε το σπίτι μας στη Λυών με μια βίλα στην Κορσική. Κόστος: 0 €."',
  pas_de_monnaie__pas_de_points__juste_un_accord_entre_deux_propri_taires__je_viens_chez_toi__tu_viens_chez_moi_:
    "Χωρίς κέρματα, χωρίς πόντους. Απλά μια συμφωνία μεταξύ δύο ιδιοκτητών. Έρχομαι σπίτι σου, εσύ έλα σπίτι μου.",
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous_mettez_d_accord_pour__changer_vos_logements_:
    "Βρίσκετε ένα μέλος που σας αρέσει και συμφωνείτε να ανταλλάξετε καταλύματα.",
  pas_de_points___compter__juste_le_plaisir_de_partager_et_de_se_rencontrer_:
    "Δεν υπάρχουν βαθμοί για μέτρηση. Μόνο η ευχαρίστηση του μοιράσματος και της συνάντησης.",
  plus_qu_une__conomie__c_est_une_nouvelle_fa_on_de_voyager_:
    "Περισσότερο από οικονομία, είναι ένας νέος τρόπος ταξιδιού.",
  les__changes_sont_totalement_gratuits__pas_de_frais_de_service__pas_de_frais_de_m_nage__sauf_accord_sp_cifique__:
    "Οι ανταλλαγές είναι εντελώς δωρεάν. Χωρίς χρέωση υπηρεσιών, χωρίς τέλη καθαρισμού (εκτός εάν έχει συμφωνηθεί ειδικά).",
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_accueillez_quelqu_un_qui_conna_t_la_valeur_d_un_logement_:
    "Μόνο επαληθευμένοι οικοδεσπότες μπορούν να κάνουν συναλλαγές. Καλωσορίζετε κάποιον που γνωρίζει την αξία ενός σπιτιού.",
  oubliez_la_valeur_des_points__une_nuit_est_une_nuit__l__change_est_bas__sur_la_confiance_entre_h_tes_:
    "Ξεχάστε την αξία των πόντων. Μια νύχτα είναι μια νύχτα. Η ανταλλαγή βασίζεται στην εμπιστοσύνη μεταξύ των οικοδεσποτών.",
  __an: "/ έτος",
  _changes_dans_toute_l_europe_entre_h_tes_airbnb_no:
    "Ανταλλαγές σε όλη την Ευρώπη μεταξύ οικοδεσποτών Airbnb με βαθμολογία 4,5+. Προσφορά κυκλοφορίας 2026: -50%.",
  apr_s_des_mois_d_accueil__transformez_vos_p_riodes:
    "Μετά από μήνες φιλοξενίας, μετατρέψτε τις αργές περιόδους σας σε πραγματικό χώρο αναπνοής χωρίς να πλήξετε τον προϋπολογισμό σας.",
  prenez_du_recul_pour__viter_l__puisement_li____l_a:
    "Κάντε ένα βήμα πίσω για να αποφύγετε την εξάντληση από τη συνεχή φιλοξενία.",
  accueillez_des_h_tes_qui_connaissent_d_j__les_exig:
    "Καλωσορίστε επισκέπτες που γνωρίζουν ήδη τις απαιτήσεις του πεδίου και, στη συνέχεια, μοιραστείτε τις μεθόδους και τα σχόλιά σας.",
  voyagez___co_t_r_duit_gr_ce_aux__changes_entre_mem:
    "Ταξιδέψτε με μειωμένο κόστος χάρη στις ανταλλαγές μεταξύ των μελών του κλαμπ.",
  quand_votre_quota_local_est_atteint__vous_pouvez__:
    "Όταν συμπληρωθεί το τοπικό σας όριο, μπορείτε να κάνετε συναλλαγές εκτός πλατφόρμας με την επιφύλαξη τοπικής συμμόρφωσης.",
  la_r_volution_des_h_tes_en_europe: "Η επανάσταση υποδοχής στην Ευρώπη",
  enfin_une_pause_pour_les_h_tes_airbnb_not_s_4_5_:
    "Τέλος, ένα διάλειμμα για τους οικοδεσπότες της Airbnb με βαθμολογία 4,5+",
  traveltrok_est_une_r_volution_europ_enne__une_plat:
    "Το DONKEY TRAVEL είναι μια ευρωπαϊκή επανάσταση: μια πλατφόρμα ανταλλαγής για επισκέπτες που ήδη πληρώνουν για θέρμανση, φόρους, ηλεκτρισμό, internet και συντήρηση και καλωσορίζουν όλο το χρόνο σαν σε ξενοδοχείο. Εδώ, αλληλεπιδράτε με οικοδεσπότες που ξέρουν πώς να σας καλωσορίζουν, μοιράζεστε τις εμπειρίες σας, μετά πηγαίνετε και ανακαλύπτετε ένα άλλο μέρος χωρίς να ξοδέψετε τα χρήματα.",
  prix_garanti___vie_pour_les_1000_premiers_inscrits:
    "Τιμή εγγυημένη εφ' όρου ζωής για τις πρώτες 1000 εγγραφές.",
  chez_traveltrok__vos_donn_es_ne_sont_pas_un_produi:
    "Στο DONKEY TRAVEL, τα δεδομένα σας δεν είναι προϊόν.",
  nous_ne_vendons_jamais_les_informations_de_nos_mem:
    "Δεν πουλάμε ποτέ τα στοιχεία των μελών μας.",
  nous_ne_partageons_aucune_donn_e_avec_des_tiers___:
    "Δεν μοιραζόμαστε δεδομένα με τρίτους για εμπορικούς σκοπούς.",
  le_site_est_s_curis__et_vos__changes_restent_priv_:
    "Ο ιστότοπος είναι ασφαλής και οι ανταλλαγές σας παραμένουν ιδιωτικές.",
  traveltrok_est_garanti_sans_publicit____vous__tes_:
    "Το DONKEY TRAVEL είναι εγγυημένο χωρίς διαφημίσεις: εσείς είστε το μέλος και όχι το προϊόν.",
  ___notre_mod_le_repose_uniquement_sur_les_abonneme:
    "👉 Το μοντέλο μας βασίζεται αποκλειστικά στις συνδρομές και όχι στην εκμετάλλευση δεδομένων.",
  ___sans_publicit___sans_revente_de_donn_es__100___:
    "🔒 Χωρίς διαφημίσεις. Χωρίς μεταπώληση δεδομένων. 100% χρηματοδοτείται από τα μέλη.",
  le_club_n_est_pas_un_conseil_juridique___chaque_me:
    "Ο σύλλογος δεν παρέχει νομικές συμβουλές. κάθε μέλος πρέπει να σέβεται τους τοπικούς κανόνες (δηλώσεις, ποσοστώσεις, συνιδιοκτησία, φορολογία κ.λπ.).",
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_:
    "Μια ευρωπαϊκή πλατφόρμα ανταλλαγής που προορίζεται για οικοδεσπότες της Airbnb",
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_u:
    "Ιδιωτικό κλαμπ για επισκέπτες με βαθμολογία 4,5+: μια μοναδική συνδρομή για ανταλλαγή σε όλη την Ευρώπη.",
  acc_s_r_serv_: "Δέσμευση πρόσβασης",
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_:
    "Κρατήθηκε για οικοδεσπότες Airbnb με βαθμολογία μεγαλύτερη ή ίση με 4,5.",
  europe_unique: "Ενιαία Ευρώπη",
  "50eur_an_pour__changer_dans_toute_l_europe_":
    "50 EUR/έτος για ανταλλαγή σε όλη την Ευρώπη.",
  lancement_2026: "Έναρξη 2026",
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eu:
    "Μείωση 50% το 2026: 25 ευρώ/έτος αντί για 50 ευρώ/έτος. Τιμή εγγυημένη εφ' όρου ζωής για τις πρώτες 1000 εγγραφές.",
  club_d__change_h_tes_airbnb: "Airbnb Host Exchange Club",
  optimisez_vos_p_riodes_creuses_gr_ce_aux__changes:
    "Βελτιστοποιήστε τις περιόδους εκτός αιχμής χάρη στις ανταλλαγές",
  basse_saison__pause__rencontres_entre_h_tes___cono:
    "Χαμηλή περίοδος, διαλείμματα, συναντήσεις μεταξύ επισκεπτών, εξοικονόμηση πόρων για διακοπές: όλα είναι σχεδιασμένα για ενεργούς επισκέπτες στην Ευρώπη.",
  r_serv__aux_h_tes_traveltrok:
    "Έγινε κράτηση για επισκέπτες του DONKEY TRAVEL",
  voyagez_gratuitement_gr_ce___votre_logement:
    "Ταξιδέψτε δωρεάν με τη διαμονή σας",
  accueillez_des_membres_et_faites_vous_accueillir_e:
    "Καλώς ήρθατε στα μέλη και σας καλωσορίζουμε ξανά. Μια απλή, άμεση και χωρίς μετρητά ανταλλαγή μεταξύ των ιδιοκτητών.",
  devenir_h_te: "Γίνετε οικοδεσπότης",
  comment__a_marche__: "Πώς λειτουργεί;",
  _nous_avons__chang__notre_maison___lyon_contre_une:
    '"Αναλλάξαμε το σπίτι μας στη Λυών με μια βίλα στην Κορσική. Κόστος: 0 €."',
  amis_partageant_un_repas_en_corse:
    "Φίλοι που μοιράζονται ένα γεύμα στην Κορσική",
  sophie___marc__membres_depuis_2023: "Sophie & Marc, μέλη από το 2023",
  pas_besoin_d__changer_aux_m_mes_dates____tu_viens:
    "Δεν χρειάζεται ανταλλαγή στις ίδιες ημερομηνίες: εσύ έρχεσαι σπίτι μου τον Ιούνιο, εγώ έρχομαι σπίτι σου τον Σεπτέμβριο!",
  l__change_direct___simple_et_humain: "Άμεση ανταλλαγή: απλή και ανθρώπινη",
  pas_de_monnaie__pas_de_points__juste_un_accord_ent:
    "Χωρίς κέρματα, χωρίς πόντους. Απλά μια συμφωνία μεταξύ δύο ιδιοκτητών. Έρχομαι σπίτι σου, εσύ έλα σπίτι μου.",
  "1__accord_mutuel": "1. Αμοιβαία συμφωνία",
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous:
    "Βρίσκετε ένα μέλος που σας αρέσει και συμφωνείτε να ανταλλάξετε καταλύματα.",
  "2__flexibilit__totale": "2. Απόλυτη ευελιξία",
  "3__z_ro_comptabilit_": "3. Μηδενική λογιστική",
  pas_de_points___compter__juste_le_plaisir_de_parta:
    "Δεν υπάρχουν βαθμοί για μέτρηση. Μόνο η ευχαρίστηση του μοιράσματος και της συνάντησης.",
  pourquoi_les_h_tes_adorent_ce_syst_me__:
    "Γιατί οι οικοδεσπότες αγαπούν αυτό το σύστημα;",
  plus_qu_une__conomie__c_est_une_nouvelle_fa_on_de_:
    "Περισσότερο από οικονομία, είναι ένας νέος τρόπος ταξιδιού.",
  "0__de_frais": "0€ τέλη",
  les__changes_sont_totalement_gratuits__pas_de_frai:
    "Οι ανταλλαγές είναι εντελώς δωρεάν. Χωρίς χρέωση υπηρεσιών, χωρίς τέλη καθαρισμού (εκτός εάν έχει συμφωνηθεί ειδικά).",
  confiance_totale: "Απόλυτη εμπιστοσύνη",
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_ac:
    "Μόνο επαληθευμένοι οικοδεσπότες μπορούν να κάνουν συναλλαγές. Καλωσορίζετε κάποιον που γνωρίζει την αξία ενός σπιτιού.",
  simplicit_: "Απλότητα",
  oubliez_la_valeur_des_points__une_nuit_est_une_nui:
    "Ξεχάστε την αξία των πόντων. Μια νύχτα είναι μια νύχτα. Η ανταλλαγή βασίζεται στην εμπιστοσύνη μεταξύ των οικοδεσποτών.",
  rejoignez_la_communaut__des_h_tes: "Γίνετε μέλος της κοινότητας υποδοχής",
  rejoignez_la_communaut__et_commencez____changer_:
    "Γίνετε μέλος της κοινότητας και ξεκινήστε τη συνομιλία.",
  commencer_maintenant: "Ξεκινήστε τώρα",
  chargement___: "Φόρτωση...",
  accueil: "Καλωσόρισμα",
  comment_a_marche: "Πώς λειτουργεί",
  vos_engagements: "Οι δεσμεύσεις σας",
  pays: "Χώρα",
  logements: "Στέγαση",
  _change_h_te: "Ανταλλαγή κεντρικού υπολογιστή",
  devenir_membre: "Γίνετε μέλος",
  se_d_connecter: "Αποσυνδεθείτε",
  mon_espace: "Ο χώρος μου",
  connexion: "Σύνδεση",
  connect_: "Συνδεδεμένος",
  visuel_en_cours_de_g_n_ration_ai___:
    "Οπτική τεχνητή νοημοσύνη που δημιουργείται...",
  tableau_de_bord: "Ταμπλό",
  mes_annonces: "Οι διαφημίσεις μου",
  o__je_veux_aller: "Εκεί που θέλω να πάω",
  qui_veut_venir_chez_moi: "Έξυπνη αντιστοίχιση",
  destinations: "Προορισμοί",
  carte_des_membres: "Κάρτα μελών",
  calendrier: "Ημερολόγιο",
  votre_coffre: "Το χρηματοκιβώτιο σας",
  favoris: "Αγαπημένα",
  messages: "Μηνύματα",
  mon_profil: "Το προφίλ μου",
  pr_f_rences: "Προτιμήσεις",
  profil: "Προφίλ",
  h_te: "Πλήθος",
  membre_fondateur: "Ιδρυτικό Μέλος",
  membre: "Μέλος",
  r_duire__tendre: "Μείωση/επέκταση",
  r_duire_le_menu: "Σύμπτυξη μενού",
  cette_page_n_a_pas__t__g_n_r_e: "Αυτή η σελίδα δεν δημιουργήθηκε",
  donne_moi_plus_de_d_tails_sur_cette_page_pour_que_je_puisse_la_g_n_rer:
    "Δώστε μου περισσότερες λεπτομέρειες σχετικά με αυτήν τη σελίδα για να μπορέσω να τη δημιουργήσω",
  connexion_en_cours___: "Σύνδεση σε εξέλιξη...",
  email_ou_mot_de_passe_incorrect: "Λάθος email ή κωδικός πρόσβασης",
  une_erreur_est_survenue: "Παρουσιάστηκε σφάλμα",
  erreur_de_connexion_google: "Σφάλμα σύνδεσης Google",
  connecte_toi_pour_retrouver_ta_communaut_:
    "Συνδεθείτε για να βρείτε την κοινότητά σας",
  rejoins_la_communaut__des_h_tes_traveltrok:
    "Γίνετε μέλος της κοινότητας φιλοξενίας DONKEY TRAVEL",
  inscription: "Εγγραφή",
  continuer_avec_google: "Συνεχίστε με την Google",
  ou: "Ή",
  ton_pr_nom_et_nom: "Το όνομα και το επίθετό σας",
  jean_h_mar: "Jean Hemar",
  lien_annonce_airbnb: "Σύνδεσμος στην καταχώρισή σας στην Airbnb",
  veuillez_saisir_un_lien_airbnb_valide: "Δώστε έναν έγκυρο σύνδεσμο Airbnb",
  lien_calendrier_ical:
    "Σύνδεσμος iCal στο ημερολόγιό σας Airbnb (προαιρετικό προς το παρόν)",
  lien_ical_explication_lecture_seule:
    "Το Donkey Travel δεν αλλάζει ποτέ το ημερολόγιό σας στην Airbnb. Απλώς το διαβάσαμε για να δείξουμε τη διαθεσιμότητά σας. Θα πρέπει να συνεχίσετε να αποκλείετε μη αυτόματα τις ημερομηνίες εξαργύρωσης στην Airbnb για να αποφύγετε διπλές κρατήσεις.",
  note_airbnb: "Βαθμολογία Airbnb",
  abonnement: "Συνδρομή",
  europe_unique___50eur_an: "Ενιαία Ευρώπη - 50 EUR/έτος",
  offre_lancement_2026__25eur_an___50__:
    "Προσφορά κυκλοφορίας 2026: 25 EUR/έτος (-50%)",
  prix_garanti___vie_pour_les_1000_premiers_inscrits_:
    "Τιμή εγγυημένη εφ' όρου ζωής για τις πρώτες 1000 εγγραφές.",
  mot_de_passe: "Σύνθημα",
  "8_caract_res_minimum": "8 χαρακτήρες τουλάχιστον",
  connexion___: "Σύνδεση...",
  cr_ation_du_compte___: "Δημιουργία λογαριασμού...",
  se_connecter: "Συνδεθείτε",
  cr_er_mon_compte: "Δημιουργήστε τον λογαριασμό μου",
  mot_de_passe_oubli___: "Ξεχάσατε τον κωδικό πρόσβασης;",
  en_cr_ant_un_compte__tu_acceptes_nos_:
    "Δημιουργώντας έναν λογαριασμό, συμφωνείτε με το δικό μας",
  cgu: "CGU",
  _et_notre_: "και το δικό μας",
  politique_de_confidentialit_: "Πολιτική Απορρήτου",
  r_servation_de_logements: "Κράτηση καταλύματος",
  support_h_te_prioritaire: "Υποστήριξη κεντρικού υπολογιστή προτεραιότητας",
  carte___filtres_avanc_s: "Χάρτης + προηγμένα φίλτρα",
  flux_de_r_servation__tape_par__tape: "Βήμα προς βήμα ροή κρατήσεων",
  couverture_dommages_assistance: "Κάλυψη ζημιών/βοήθειας",
  multi_logements___reporting: "Πολυκατοικία + αναφορά",
  comparatif_des_modes: "Σύγκριση τρόπων λειτουργίας",
  ce_que_tu_actives_selon_ton_usage_traveltrok_:
    "Τι ενεργοποιείτε ανάλογα με τη χρήση του TRAVELTROK.",
  fonction: "Λειτουργία",
  voyageur: "Ταξιδιώτης",
  pro: "Pro",
  abonnement_europe_unique: "Συνδρομή για ενιαία Ευρώπη",
  rejoindre_le_club_europe: "Γίνετε μέλος της λέσχης Ευρώπης",
  basse_saison: "Χαμηλή σεζόν",
  pause: "Κάντε ένα διάλειμμα",
  rencontres: "Γνωρίστε τους οικοδεσπότες",
  _conomies: "Οικονομίες",
  quota_atteint: "Συμπληρώθηκε η ποσόστωση",
  _ligibilit_: "Αιρετότητα",
  zone_d__change: "Χώρος ανταλλαγής",
  toute_l_europe: "Όλη η Ευρώπη",
  mod_le: "Μοντέλο",
  abonnement_unique_annuel: "Ενιαία ετήσια συνδρομή",
  propri_taire_europ_en_en_pause: "Ευρωπαίος ιδιοκτήτης σε διάλειμμα",
  v_rification: "Επαλήθευση",
  h_tes_certifi_s: "Πιστοποιημένοι οικοδεσπότες",
  abonnement_unique_traveltrok: "Ενιαία συνδρομή DONKEY TRAVEL",
  offre_lancement_2026__25eur_an_au_lieu_de_50eur_an:
    "Προσφορά κυκλοφορίας 2026: 25 EUR/έτος αντί για 50 EUR/έτος",
  pourquoi_ce_club_fonctionne_pour_les_h_tes:
    "Γιατί αυτός ο σύλλογος λειτουργεί για οικοδεσπότες",
  chez_traveltrok__vos_donn_es_ne_sont_pas_un_produit_:
    "Στο DONKEY TRAVEL, τα δεδομένα σας δεν είναι προϊόν.",
  nous_ne_vendons_jamais_les_informations_de_nos_membres_:
    "Δεν πουλάμε ποτέ τα στοιχεία των μελών μας.",
  nous_ne_partageons_aucune_donn_e_avec_des_tiers___des_fins_commerciales_:
    "Δεν μοιραζόμαστε δεδομένα με τρίτους για εμπορικούς σκοπούς.",
  le_site_est_s_curis__et_vos__changes_restent_priv_s_:
    "Ο ιστότοπος είναι ασφαλής και οι ανταλλαγές σας παραμένουν ιδιωτικές.",
  traveltrok_est_garanti_sans_publicit____vous__tes_le_membre__pas_le_produit_:
    "Το DONKEY TRAVEL είναι εγγυημένο χωρίς διαφημίσεις: εσείς είστε το μέλος και όχι το προϊόν.",
  rejoindre_le_club: "Εγγραφείτε στο κλαμπ",
  trouver_un_h_te: "Βρείτε έναν οικοδεσπότη",
  proposer_un__change: "Προτείνετε μια ανταλλαγή",
  synchronisation_mise___jour_avec_succ_s:
    "Ο συγχρονισμός ενημερώθηκε με επιτυχία",
  erreur_lors_de_la_mise___jour: "Σφάλμα κατά την ενημέρωση",
  indisponible: "Δυσεύρετος",
  r_serv_: "Απόθεμα",
  erreur_chargement: "Σφάλμα φόρτωσης",
  inconnue: "Αγνωστος",
  impossible_de_r_cup_rer_le_calendrier_ical__v_rifiez_l_url_ical_airbnb_et_r_essayez_:
    "Δεν είναι δυνατή η ανάκτηση του ημερολογίου iCal. Ελέγξτε τη διεύθυνση URL του iCal Airbnb και δοκιμάστε ξανά.",
  r_servation: "Κράτηση",
  _v_nements_synchronis_s: "συγχρονισμένα συμβάντα",
  _v_nements_import_s: "εισαγόμενα γεγονότα",
  erreur_sync: "Σφάλμα συγχρονισμού",
  _chec_de_synchronisation: "Αποτυχία συγχρονισμού",
  dates_bloqu_es_avec_succ_s: "Οι ημερομηνίες μπλοκαρίστηκαν με επιτυχία",
  erreur_blocage: "Σφάλμα αποκλεισμού",
  mois: "Μήνας",
  aujourd_hui: "Σήμερα",
  d_tails: "Καθέκαστα",
  actions: "Δράσεις",
  bloquer: "Να μπλοκάρει",
  filtres: "Φίλτρα",
  confirm_: "Επιβεβαιωμένος",
  en_attente: "Σε αναμονή",
  proposition: "Πρόταση",
  bloqu_: "Αποκλεισμένος",
  synchronisation: "Συγχρονισμός",
  configurer: "Διαμόρφωση",
  airbnb_connect_: "Συνδέθηκε η Airbnb",
  derni_re_synchro_r_ussie: "Τελευταίος επιτυχημένος συγχρονισμός",
  derni_re_synchro_en__chec: "Τελευταίος αποτυχημένος συγχρονισμός",
  calendrier_connect___lancez_une_synchro_pour_importer_vos_r_servations_airbnb_:
    "Συνδεδεμένο ημερολόγιο. Ξεκινήστε έναν συγχρονισμό για να εισαγάγετε τις κρατήσεις σας στην Airbnb.",
  synchro___: "Συγχρονισμός...",
  forcer_la_synchro: "Αναγκαστικός συγχρονισμός",
  non_synchronis_: "Μη συγχρονισμένο",
  connectez_votre_calendrier_airbnb_pour__viter_les_doubles_r_servations__:
    "Συνδέστε το ημερολόγιό σας Airbnb για να αποφύγετε διπλές κρατήσεις!",
  bloquer_des_dates: "Αποκλεισμός ημερομηνιών",
  s_lection: "Επιλογή",
  jours: "ημέρες",
  raison__optionnel__ex__travaux_: "Αιτία (προαιρετικό, π.χ.: Έργα)",
  annuler: "Ματαίωση",
  confirmer: "Επιβεβαιώνω",
  synchronisation_airbnb: "Συγχρονισμός Airbnb",
  ajoutez_vos_liens_airbnb_pour_synchroniser_automatiquement_vos_r_servations_et__viter_les_doublons_:
    "Προσθέστε τους συνδέσμους σας Airbnb για να συγχρονίσετε αυτόματα τις κρατήσεις σας και να αποφύγετε τα διπλότυπα.",
  lien_de_l_annonce_airbnb: "Σύνδεσμος διαφήμισης Airbnb",
  airbnb_ical_calendar_link: "Σύνδεσμος ημερολογίου Airbnb iCal",
  disponible_dans_param_tres_de_l_annonce_export_du_calendrier:
    "Διατίθεται στις Ρυθμίσεις Ανακοίνωσης Ημερολόγιο Εξαγωγή",
  enregistrer: "Εκτός",
  veuillez_cliquer_sur__localiser__pour_valider_l_adresse_avant_de_continuer_:
    'Κάντε κλικ στην επιλογή "Εντοπισμός" για να επικυρώσετε τη διεύθυνση πριν συνεχίσετε.',
  vous_devez__tre_connect__pour_publier_:
    "Πρέπει να είστε συνδεδεμένοι για να δημοσιεύσετε.",
  id_manquant_apr_s_sauvegarde:
    "Το αναγνωριστικό λείπει μετά τη δημιουργία αντιγράφων ασφαλείας",
  erreur_upload_photo: "Σφάλμα μεταφόρτωσης φωτογραφίας",
  erreur_sauvegarde_metadata_photos:
    "Σφάλμα κατά την αποθήκευση φωτογραφιών μεταδεδομένων",
  une_erreur_est_survenue_lors_de_la_sauvegarde:
    "Παρουσιάστηκε σφάλμα κατά την αποθήκευση",
  quitter: "Να φύγω",
  modification: "Εκδίδω",
  cr_ation: "Δημιουργία",
  _tape: "Στάδιο",
  sur: "επί",
  sauvegarde_en_cours___: "Δημιουργία αντιγράφων ασφαλείας σε εξέλιξη...",
  retour: "Πίσω",
  sauvegarde___: "Εφεδρικός...",
  mettre___jour: "Για ενημέρωση",
  publier_l_annonce: "Δημοσιεύστε την αγγελία",
  suivant: "Εξής",
  _tes_vous_s_r_de_vouloir_supprimer_cette_annonce__:
    "Είστε βέβαιοι ότι θέλετε να καταργήσετε αυτήν τη διαφήμιση;",
  impossible_de_supprimer_l_annonce__:
    "Δεν είναι δυνατή η διαγραφή της διαφήμισης:",
  g_rez_vos_logements_et_leur_disponibilit__:
    "Διαχειριστείτε τα καταλύματα σας και τη διαθεσιμότητά τους.",
  ajouter_une_annonce: "Προσθέστε μια διαφήμιση",
  vous_n_avez_aucune_annonce: "Δεν έχετε διαφημίσεις",
  commencez___gagner_un_revenu_en_louant_votre_logement__c_est_simple_et_rapide_:
    "Ξεκινήστε να κερδίζετε εισόδημα ενοικιάζοντας το σπίτι σας. Είναι γρήγορο και εύκολο.",
  cr_er_ma_premi_re_annonce: "Δημιουργία της πρώτης μου διαφήμισης",
  publi_: "Δημοσιεύθηκε",
  brouillon: "Προσχέδιο",
  __nuit: "/ νύχτα",
  voir_l_annonce: "Δείτε τη διαφήμιση",
  modifier: "Για τροποποίηση",
  supprimer: "ΔΙΑΓΡΑΦΩ",
  quels__quipements_proposez_vous__: "Τι εξοπλισμό προσφέρετε;",
  s_lectionnez_tout_ce_qui_est_disponible_pour_les_voyageurs_:
    "Επιλέξτε όλα όσα είναι διαθέσιμα στους ταξιδιώτες.",
  aucun_sch_ma_conversation_compatible_trouv_:
    "Δεν βρέθηκε συμβατό διάγραμμα συνομιλίας.",
  logements_concern_s: "σχετική στέγαση",
  logement_non_pr_cis_: "Δεν προσδιορίζεται κατάλυμα",
  erreur_lors_de_l_envoi_du_message_: "Σφάλμα κατά την αποστολή μηνύματος.",
  rechercher_une_conversation: "Αναζήτηση για συνομιλία",
  demandes_re_ues: "Λήφθηκαν αιτήματα",
  mes_demandes: "Τα αιτήματά μου",
  aucune_demande_re_ue_: "Δεν ελήφθησαν αιτήματα.",
  aucune_demande_envoy_e_: "Δεν εστάλη αίτημα.",
  photo_de_profil: "Φωτογραφία προφίλ",
  localisation_non_pr_cis_e: "Η τοποθεσία δεν προσδιορίζεται",
  listing_: "Καταχώριση:",
  en_ligne: "Διαδικτυακά",
  vous: "ΕΣΕΙΣ",
  _crivez_votre_message___: "Γράψε το μήνυμά σου...",
  s_lectionnez_une_conversation: "Επιλέξτε μια συνομιλία",
  pour_commencer___changer: "για να ξεκινήσετε τις συναλλαγές",
  logement_propos_: "Προτεινόμενη διαμονή",
  description_non_pr_cis_e: "Η περιγραφή δεν προσδιορίζεται",
  ch_: "κεφ.",
  voy_: "βλέπω.",
  nuit: "νύχτα",
  prix_non_pr_cis_: "Η τιμή δεν προσδιορίζεται",
  voir: "Βλέπω",
  aucune_annonce_li_e___cette_conversation_:
    "Δεν υπάρχουν ανακοινώσεις σχετικά με αυτήν τη συνομιλία.",
  s_lectionnez_une_conversation_pour_voir_les_d_tails_:
    "Επιλέξτε μια συνομιλία για να δείτε λεπτομέρειες.",
  bonjour: "Καλημέρα",
  voici_ce_qui_se_passe_sur_votre_compte_aujourd_hui_:
    "Δείτε τι συμβαίνει στον λογαριασμό σας σήμερα.",
  annonces_en_ligne: "Διαφημίσεις στο Διαδίκτυο",
  nouveaux_messages: "Νέες αναρτήσεις",
  prochains__changes: "Επόμενες ανταλλαγές",
  matching_section__o__je_veux_aller: "Αντιστοίχιση ενότητας: Πού θέλω να πάω",
  ajoutez_jusqu__10_villes_avec_rayon_en_km_et_vos_dates_de_d_part_pour_recevoir_des_propositions_mieux_cibl_es_:
    "Προσθέστε έως και 10 πόλεις με ακτίνα σε km και τις ημερομηνίες αναχώρησής σας για να λάβετε πιο στοχευμένες προτάσεις.",
  configurer_mes_pr_f_rences: "Διαμόρφωση των προτιμήσεών μου",
  pr_t___recevoir_vos_premiers_voyageurs__:
    "Είστε έτοιμοι να υποδεχτείτε τους πρώτους σας ταξιδιώτες;",
  compl_tez_votre_profil_et_publiez_votre_premi_re_annonce_pour_commencer_____changer_votre_logement_avec_la_communaut__traveltrok_:
    "Ολοκληρώστε το προφίλ σας και δημοσιεύστε την πρώτη σας διαφήμιση για να αρχίσετε να ανταλλάσσετε τη διαμονή σας με την κοινότητα του TravelΑνταλλαγή.",
  cr_er_mon_annonce: "Δημιουργία της διαφήμισής μου",
  compl_ter_mon_profil: "Συμπλήρωσε το προφίλ μου",
  impossible_de_charger_vos_preferences_:
    "Δεν είναι δυνατή η φόρτωση των προτιμήσεών σας.",
  preferences_enregistrees_: "Αποθηκευμένες προτιμήσεις.",
  impossible_d_enregistrer_vos_preferences_:
    "Δεν είναι δυνατή η αποθήκευση των προτιμήσεών σας.",
  impossible_de_supprimer_votre_profil_:
    "Δεν είναι δυνατή η διαγραφή του προφίλ σας.",
  chargement_des_preferences___: "Φόρτωση προτιμήσεων...",
  unites_de_distance: "Μονάδες απόστασης",
  kilom_tres__km_: "Χιλιόμετρα (χλμ)",
  format_europeen_par_defaut: "Προεπιλεγμένη ευρωπαϊκή μορφή",
  miles__mi_: "Μίλια (μίλια)",
  format_anglo_saxon: "Αγγλοσαξονική μορφή",
  visibilite_du_profil: "Ορατότητα προφίλ",
  mettre_mon_profil_en_pause: "Παύση του προφίλ μου",
  me_masquer_dans_les_resultats_de_recherche:
    "Απόκρυψη με από τα αποτελέσματα αναζήτησης",
  zone_sensible: "Ευαίσθητη περιοχή",
  suppression___: "Διαγραφή...",
  supprimer_mon_profil: "Διαγραφή του προφίλ μου",
  pensez_a_enregistrer_vos_modifications_:
    "Θυμηθείτε να αποθηκεύσετε τις αλλαγές σας.",
  enregistrement___: "Εγγραφή...",
  enregistrer_les_preferences: "Αποθήκευση προτιμήσεων",
  impossible_de_charger_votre_profil_:
    "Δεν είναι δυνατή η φόρτωση του προφίλ σας.",
  profil_enregistr__partiellement__la_base_de_donn_es_doit__tre_mise___jour__migration_sql__:
    "Το προφίλ αποθηκεύτηκε μερικώς. Η βάση δεδομένων πρέπει να ενημερωθεί (μεταφορά SQL).",
  profil_mis___jour_avec_succ_s_: "Το προφίλ ενημερώθηκε με επιτυχία.",
  profil_non_enregistr___la_base_de_donn_es_doit__tre_migr_e__colonnes_manquantes__:
    "Το προφίλ δεν αποθηκεύτηκε: η βάση δεδομένων πρέπει να μετεγκατασταθεί (λείπουν στήλες).",
  profil_non_enregistr___trop_de_colonnes_manquantes__lancez_la_migration_sql_:
    "Το προφίλ δεν αποθηκεύτηκε: λείπουν πάρα πολλές στήλες. Ξεκινήστε τη μετεγκατάσταση SQL.",
  votre_base_de_donn_es_n_est_pas___jour__lancez_la_migration_sql_puis_r_essayez_:
    "Η βάση δεδομένων σας δεν είναι ενημερωμένη. Εκτελέστε τη μετεγκατάσταση SQL και δοκιμάστε ξανά.",
  erreur_lors_de_la_mise___jour_: "Σφάλμα κατά την ενημέρωση.",
  photo_de_profil_mise___jour_: "Ενημερώθηκε η φωτογραφία προφίλ.",
  erreur_upload_photo_: "Σφάλμα μεταφόρτωσης φωτογραφίας.",
  photo_de_couverture_mise___jour_: "Ενημερώθηκε η φωτογραφία εξωφύλλου.",
  erreur_upload_couverture_: "Σφάλμα μεταφόρτωσης εξωφύλλου.",
  document_envoy__pour_v_rification_: "Έγγραφο που στάλθηκε για επαλήθευση.",
  erreur_lors_de_l_envoi_du_document_: "Σφάλμα κατά την αποστολή του εγγράφου.",
  impossible_de_charger_votre_profil_pour_le_moment_:
    "Δεν είναι δυνατή η φόρτωση του προφίλ σας αυτήν τη στιγμή.",
  mon_profil_h_te: "Το προφίλ του οικοδεσπότη μου",
  identit___r_seaux_et_infos_de_matching:
    "Ταυτότητα, δίκτυα και πληροφορίες αντιστοίχισης",
  plus_votre_profil_est_complet__plus_le_moteur_peut_proposer_des_h_tes_compatibles_:
    "Όσο πιο ολοκληρωμένο είναι το προφίλ σας, τόσο πιο συμβατούς κεντρικούς υπολογιστές μπορεί να προτείνει ο κινητήρας.",
  compl_tude_du_profil: "Πληρότητα προφίλ",
  couverture: "Κουβέρτα",
  photo_principale: "Κύρια φωτογραφία",
  h_te_traveltrok: "Φιλοξενεί το DANKEY TRAVEL",
  localisation_non_renseign_e: "Η τοποθεσία δεν παρέχεται",
  ajoutez_une_photo_large_pour_mieux_pr_senter_votre_univers_d_h_te_:
    "Προσθέστε μια μεγάλη φωτογραφία για να παρουσιάσετε καλύτερα τον κόσμο του οικοδεσπότη σας.",
  destinations_cibl_es: "Στοχευμένοι προορισμοί",
  dates_pr_vues: "Προγραμματισμένες ημερομηνίες",
  configurer___o__je_veux_aller__: "'Διαμόρφωση \"Πού θέλω να πάω\"'",
  statut_identit_: "Κατάσταση ταυτότητας",
  v_rifi_: "Επαληθεύτηκε",
  en_cours: "Σε εξέλιξη",
  non_v_rifi_: "Δεν έχει επαληθευτεί",
  ajoutez_une_pi_ce_d_identit__pour_renforcer_la_confiance_de_la_communaut__:
    "Προσθέστε αναγνωριστικό για να δημιουργήσετε εμπιστοσύνη στην κοινότητα.",
  envoyer_document: "Αποστολή εγγράφου",
  identit__et_contact: "Ταυτότητα και επαφή",
  pr_nom: "Ονομα",
  nom: "Ονομα",
  pseudo_public: "Δημόσιο ψευδώνυμο",
  email: "E-mail",
  t_l_phone: "Τηλέφωνο",
  r_seaux_et_liens: "Δίκτυα και σύνδεσμοι",
  site_web: "Δικτυακός τόπος",
  localisation_et_mode_de_voyage: "Τοποθεσία και τρόπος ταξιδιού",
  pays_de_r_sidence: "Χώρα διαμονής",
  s_lectionnez_un_pays: "Επιλέξτε μια χώρα",
  ville_de_r_sidence: "Πόλη κατοικίας",
  amiens: "Αμιέν",
  combien_de_personnes_voyagent__: "Πόσα άτομα ταξιδεύουν;",
  voyagez_vous_avec_des_animaux__: "Ταξιδεύετε με ζώα;",
  oui: "Ναί",
  non: "Οχι",
  voyagez_vous_avec_des_b_b_s__: "Ταξιδεύετε με μωρά;",
  bio_h_te: "Βιογραφικό οικοδεσπότη",
  pr_sentez_votre_style_d_accueil_et_votre_logement_:
    "Παρουσιάστε το στυλ φιλοξενίας και τη διαμονή σας.",
  pr_sentation_de_la_famille: "Παρουσίαση της οικογένειας",
  qui_voyage__habitudes__rythme__type_de_s_jour_recherch___:
    "Ποιος ταξιδεύει, αναζητούνται συνήθειες, ρυθμός, είδος διαμονής...",
  compl_tez_aussi___o__je_veux_aller___pour_activer_un_matching_plus_pr_cis_:
    "Συμπληρώστε επίσης το «Πού θέλω να πάω» για να ενεργοποιήσετε την ακριβέστερη αντιστοίχιση.",
  enregistrer_le_profil: "Αποθήκευση προφίλ",
  horizon_contrat: "Ορίζοντας της σύμβασης",
  "24_mois_apres_le_1er_sejour": "24 μήνες μετά την πρώτη διαμονή",
  nuits_que_je_dois: "Νύχτες που χρωστάω",
  nuits_qu_on_me_doit: "Νύχτες που χρωστάω",
  echanges_ouverts: "Ανοιχτές ανταλλαγές",
  echanges_proches_echeance: "Συναλλαγές κοντά στη λήξη",
  alerte_solde_des_echanges: "Ειδοποίηση υπολοίπου ανταλλαγής",
  aucun_profil_a_risque_detecte_pour_le_moment_:
    "Δεν έχει εντοπιστεί προφίλ κινδύνου αυτή τη στιγμή.",
  contrats_en_cours: "Τρέχουσες συμβάσεις",
  personne: "Πρόσωπο",
  logement: "Κατάλυμα",
  contrat: "ΣΥΜΒΑΣΗ",
  dates: "Ημερομηνίες",
  echange_effectue: "Πραγματοποιήθηκε ανταλλαγή",
  solde_nuits: "Εκπτωτικές βραδιές",
  temps_restant: "Χρόνος που απομένει",
  "1er_sejour_": "1η διαμονή:",
  echeance_: "Ημερομηνία λήξης:",
  ils_sont_venus__fait: "Ήρθαν: έγινε",
  ils_sont_venus__en_attente: "Ήρθαν: περιμένουν",
  je_suis_alle__fait: "πήγα: έγινε",
  je_suis_alle__en_attente: "Πήγα: περιμένω",
  je_dois: "πρέπει να",
  nuits: "νύχτες",
  on_me_doit: "χρωστάω",
  carte_des_p_rim_tres_de_recherche: "Χάρτης περιοχών έρευνας",
  villes_localis_es: "τοπικές πόλεις",
  mise___jour_de_la_carte___: "Ενημέρωση χάρτη...",
  vous_devez__tre_connect__pour_g_rer_vos_pr_f_rences_:
    "Πρέπει να είστε συνδεδεμένοι για να διαχειριστείτε τις προτιμήσεις σας.",
  impossible_de_charger_vos_pr_f_rences_de_matching_pour_le_moment_:
    "Δεν είναι δυνατή η φόρτωση των προτιμήσεων που ταιριάζουν αυτήν τη στιγμή.",
  ajoutez_au_moins_une_ville_cible_pour_activer_le_matching_:
    "Προσθέστε τουλάχιστον μία πόλη-στόχο για να ενεργοποιήσετε την αντιστοίχιση.",
  une_p_riode_a_une_date_de_fin_ant_rieure___la_date_de_d_part_:
    "Μια περίοδος έχει ημερομηνία λήξης πριν από την ημερομηνία έναρξης.",
  s_lectionnez_au_moins_un_pays_si_vous_activez_le_filtre_de_contact_par_pays_:
    "Επιλέξτε τουλάχιστον μία χώρα εάν ενεργοποιήσετε το φίλτρο επαφών ανά χώρα.",
  pr_f_rences_enregistr_es__les_pays_cibl_s_sont_conserv_s_localement_tant_que_la_migration_sql_n_est_pas_appliqu_e_:
    "Αποθηκευμένες προτιμήσεις. Οι στοχευμένες χώρες διατηρούνται τοπικά μέχρι να εφαρμοστεί η μετεγκατάσταση SQL.",
  pr_f_rences_de_matching_enregistr_es_avec_succ_s_:
    "Οι προτιμήσεις που ταιριάζουν αποθηκεύτηκαν με επιτυχία.",
  pr_f_rences_non_enregistr_es__base_non_migr_e__lancez_la_migration_sql_:
    "Οι προτιμήσεις δεν αποθηκεύτηκαν: η βάση δεδομένων δεν μετεγκαταστάθηκε. Ξεκινήστε τη μετεγκατάσταση SQL.",
  erreur_lors_de_l_enregistrement_: "Σφάλμα αποθήκευσης.",
  matching_intelligent: "Έξυπνη αντιστοίχιση",
  indiquez_vos_villes_cibles_et_vos_p_riodes_de_d_part__traveltrok_pourra_proposer_les_h_tes_les_plus_compatibles_:
    "Υποδείξτε τις πόλεις-στόχους και τις περιόδους αναχώρησής σας: Το DONKEY TRAVEL θα μπορεί να προσφέρει τους πιο συμβατούς οικοδεσπότες.",
  retour_au_profil: "Επιστροφή στο προφίλ",
  villes_et_rayon_de_recherche: "Πόλεις και ακτίνα αναζήτησης",
  jusqu___10_villes__ex__amiens_2_km__paris_5_km__lille_20_km__:
    "Έως 10 πόλεις (π.χ.: Αμιένη 2 χλμ., Παρίσι 5 χλμ., Λιλ 20 χλμ.).",
  villes_actives: "ενεργές πόλεις",
  ville: "Πόλη",
  choisir_un_pays: "Επιλέξτε χώρα",
  saisissez_une_ville: "Εισαγάγετε μια πόλη",
  choisissez_le_pays_d_abord: "Επιλέξτε πρώτα τη χώρα",
  rayon: "Ακτίνα",
  supprimer_cette_ville: "Διαγράψτε αυτήν την πόλη",
  ajouter_une_ville: "Προσθέστε μια πόλη",
  ces_villes_seront_utilis_es_pour_proposer_des_changes_cibl_s_:
    "Αυτές οι πόλεις θα χρησιμοποιηθούν για να προσφέρουν στοχευμένες ανταλλαγές.",
  enregistrer_mes_pr_f_rences: "Αποθηκεύστε τις προτιμήσεις μου",
  pays_d_europe___visiter: "Ευρωπαϊκές χώρες για επίσκεψη",
  cochez_les_pays_qui_vous_int_ressent__vous_pouvez_ensuite_limiter_les_prises_de_contact___ces_pays_:
    "Ελέγξτε τις χώρες που σας ενδιαφέρουν. Στη συνέχεια, μπορείτε να περιορίσετε τις επαφές σε αυτές τις χώρες.",
  pays_s_lectionn_s: "επιλεγμένες χώρες",
  tout_cocher: "Ελέγξτε όλα",
  tout_d_cocher: "Καταργήστε την επιλογή όλων",
  _tre_contact__uniquement_par_les_membres_de_ces_pays:
    "Να επικοινωνήσουν μόνο μέλη από αυτές τις χώρες",
  ce_filtre_sera_utilis__dans_votre_matching_automatique_:
    "Αυτό το φίλτρο θα χρησιμοποιηθεί για την αυτόματη αντιστοίχιση.",
  union_europ_enne: "Ευρωπαϊκή Ένωση",
  hors_union_europ_enne: "Εκτός Ευρωπαϊκής Ένωσης",
  agenda_des_d_parts_souhait_s: "Πρόγραμμα επιθυμητών αναχωρήσεων",
  ajoutez_les_p_riodes_o__vous_souhaitez_partir_pour_lancer_un_matching_sur_des_cr_neaux_communs_:
    "Προσθέστε τις περιόδους που θέλετε να φύγετε για να αρχίσετε να ταιριάζετε σε κοινούς κουλοχέρηδες.",
  p_riode_s__active_s_: "ενεργές περίοδοι",
  aucune_p_riode_ajout_e_pour_le_moment_: "Δεν έχουν προστεθεί ακόμη περίοδοι.",
  p_riode: "Περίοδος",
  supprimer_cette_p_riode: "Διαγραφή αυτής της περιόδου",
  d_part: "Αναχώρηση",
  commentaire__optionnel_: "Σχόλιο (προαιρετικό)",
  ajouter_une_p_riode: "Προσθέστε μια περίοδο",
  r_sum__matching: "Συνοπτική αντιστοίχιση",
  villes_cibles: "Πόλεις-στόχοι",
  rayon_moyen: "Μέση ακτίνα",
  p_riodes_planifi_es: "Προγραμματισμένες περιόδους",
  pays_cibl_s: "Στοχευμένες χώρες",
  contacts_limit_s_aux_pays_coch_s:
    "Οι επαφές περιορίζονται σε επιλεγμένες χώρες",
  contacts_ouverts___tous_les_pays:
    "Οι επαφές είναι ανοιχτές σε όλες τις χώρες",
  agenda_aper_u: "Επισκόπηση ατζέντας",
  ajoutez_une_p_riode_pour_afficher_votre_agenda_de_d_part_:
    "Προσθέστε μια περίοδο για να εμφανίσετε το ημερολόγιο αναχωρήσεών σας.",
  sans_commentaire: "Κανένα σχόλιο",
  logement_traveltrok: "διαμονή DONKEY TRAVEL",
  localisation_a_preciser: "Θέση που πρέπει να καθοριστεί",
  logements_trouves: "βρέθηκε κατάλυμα",
  plus_recents: "Το πιο πρόσφατο",
  capacite_max: "Μέγιστη χωρητικότητα",
  h_tes: "Οικοδεσπότες",
  villes: "πόλεις",
  logements_disponibles: "Διαθέσιμα καταλύματα",
  pays_disponibles: "Διαθέσιμες χώρες",
  marie_accepte__: "Η Μαρία δέχεται!",
  nuits_a_reims_contre: "νύχτες στη Ρεμς κατά",
  nuits_a_paris: "νύχτες στο Παρίσι",
  l_histoire_de_marie_jean: "Η ιστορία της Marie & Jean",
  "1__marie_consulte_l_agenda_de_jean":
    "1. Η Μαρί συμβουλεύεται το ημερολόγιο του Ζαν",
  elle_voit_que_jean_a_des_dates_libres_dans_2_semaines__parfait_pour_elle___jean_confirme_qu_il_peut_liberer_ces_dates_:
    "Βλέπει ότι ο Ζαν έχει ελεύθερα ραντεβού σε 2 εβδομάδες. Τέλειο για εκείνη! Ο Jean επιβεβαιώνει ότι μπορεί να ανακοινώσει αυτές τις ημερομηνίες.",
  h_tes_actifs: "Ενεργοί οικοδεσπότες",
  pays_couverts: "Καλυπτόμενες χώρες",
  echanges_realises: "Πραγματοποιήθηκαν ανταλλαγές",
  "100__match": "Ταίριασμα 100%.",
  echanges_longue_distance: "Υπεραστικές ανταλλαγές",
  matching_algorithmique_intelligent: "Έξυπνη αλγοριθμική αντιστοίχιση",
  notre_algorithme_croise_les_informations_de_votre_profil_et_de_vos_recherches_pour_vous_proposer_toutes_les_annonces_de_logements_qui_correspondent_exactement_a_votre_demande_:
    "Ο αλγόριθμός μας διασταυρώνει τις πληροφορίες από το προφίλ σας και τις αναζητήσεις σας για να σας προσφέρει όλες τις διαφημίσεις στέγασης που αντιστοιχούν ακριβώς στο αίτημά σας.",
  matching_precis: "Ακριβής αντιστοίχιση",
  analyse_intelligente_de_vos_crit_res: "Έξυπνη ανάλυση των κριτηρίων σας",
  gain_de_temps_dans_vos_recherches: "Εξοικονομήστε χρόνο στην έρευνά σας",
  propositions_ultra_pertinentes: "Εξαιρετικά σχετικές προτάσεις",
  habitants: "κατοίκους",
  destinations_europeennes: "Ευρωπαϊκοί προορισμοί",
  decouvrez_les_merveilles_du_continent: "Ανακαλύψτε τα θαύματα της ηπείρου",
  pays_actifs_sur_traveltrok: "Χώρες που δραστηριοποιούνται στο DONKEY TRAVEL",
  selectionner_un_pays: "Επιλέξτε μια χώρα",
  union_europeenne: "Ευρωπαϊκή Ένωση",
  hors_union_europeenne: "Εκτός Ευρωπαϊκής Ένωσης",
  fiche_detaillee: "Αναλυτικό φύλλο",
  selectionnez_un_pays_dans_la_liste_ou_sur_la_carte_pour_decouvrir_climat__population_et_lieux_emblematiques_:
    "Επιλέξτε μια χώρα από τη λίστα ή στον χάρτη για να ανακαλύψετε το κλίμα, τον πληθυσμό και τα εμβληματικά μέρη.",
  logements_actifs: "ενεργή στέγαση",
  climat: "Κλίμα",
  information_touristique: "Τουριστικές Πληροφορίες",
  lieux_emblematiques: "Εμβληματικά μέρη",
  gastronomie: "Γαστρονομία",
  dom_tom___outre_mer: "DOM-TOM / Εξωτερικό",
  villes_principales: "Κύριες πόλεις",
  charte_officielle: "Επίσημος χάρτης",
  confiance_mutuelle: "Αμοιβαία εμπιστοσύνη",
  r_gles_claires: "Σαφείς κανόνες",
  sanctions_applicables: "Ισχύουσες κυρώσεις",
  illustration_3d_des_engagements: "τρισδιάστατη απεικόνιση των δεσμεύσεων",
  concept_3d_informations: "τρισδιάστατη εικόνα λεπτομερειών",
  principe_1: "Αρχή 1",
  v_racit__des_informations: "Αλήθεια πληροφοριών",
  profil__logement__photos_et_prix_doivent__tre_exacts_:
    "Το προφίλ, η διαμονή, οι φωτογραφίες και οι τιμές πρέπει να είναι ακριβή.",
  concept_3d_respect_du_lieu: "τρισδιάστατη εικόνα σεβασμού για τον τόπο",
  principe_2: "Αρχή 2",
  respect_du_lieu: "Σεβασμός στον τόπο",
  aucune_f_te_et_z_ro_nuisance_pour_le_voisinage_:
    "Χωρίς πάρτι και μηδενική όχληση στη γειτονιά.",
  concept_3d_fiabilit__contractuelle: "Έννοια της σύμβασης σε 3d",
  principe_3: "Αρχή 3",
  fiabilit__contractuelle: "Συμβατική αξιοπιστία",
  dates_bloqu_es___engagement_ferme__sauf_raison_valable_:
    "Μπλοκαρισμένες ημερομηνίες = σταθερή δέσμευση, εκτός εάν υπάρχει βάσιμος λόγος.",
  engagements_c_t__voyageur: "Δεσμεύσεις από την πλευρά του συνοδηγού",
  engagements_c_t__h_te: "Δεσμεύσεις από την πλευρά του οικοδεσπότη",
  annulations_et_reports: "Ακυρώσεις και αναβολές",
  r_gle_op_rationnelle: "Κανόνας λειτουργίας",
  check_list_d_part_voyageur: "Λίστα ελέγχου αναχώρησης",
  cuisine_et_vaisselle_propres: "Καθαρή κουζίνα και πιάτα",
  sols_et_surfaces_rendus_propres: "Τα δάπεδα και οι επιφάνειες καθαρίζονται",
  linge_utilis__d_pos__selon_consigne:
    "Χρησιμοποιημένα σεντόνια κατάθεση σύμφωνα με τις οδηγίες",
  aucune_invitation_non_autoris_e_pendant_le_s_jour:
    "Χωρίς μη εξουσιοδοτημένες προσκλήσεις",
  _tat_final_du_logement_confirm__avec_photos:
    "Επιβεβαιώθηκε η τελική κατάσταση της στέγασης",
  sanctions_en_cas_de_manquement: "Κυρώσεις σε περίπτωση μη συμμόρφωσης",
  ce_que_permet_traveltrok: "Τι επιτρέπει το DONKEY TRAVEL",
  vous_pouvez_inscrire_autant_de_logements_que_vous_voulez_:
    "Μπορείτε να απαριθμήσετε όσα καταλύματα θέλετε.",
  vous_pouvez__changer_autant_de_fois_que_vous_voulez_dans_l_ann_e_:
    "Ανταλλαγή χωρίς όριο επανάληψης κατά τη διάρκεια του έτους.",
  chaque__change_repose_sur_un_contrat_clair_entre_deux_h_tes_:
    "Ένα επίσημο συμβόλαιο δεσμεύει επίσημα τους οικοδεσπότες και εγγυάται την επιτυχία.",
  r_f_rences_de_bonnes_pratiques: "Αναφορές βέλτιστης πρακτικής",
  un_club_s_rieux__une_communaut__durable:
    "Ένας σοβαρός σύλλογος δημιουργεί μια διαρκή κοινότητα",
  retour_au_guide_complet: "Επιστροφή στον πλήρη οδηγό",
  carte_des_logements_traveltrok: "Χάρτης διαμονής DONKEY TRAVEL",
  points_logements: "Σημεία διαμονής",
  aucune_donnee_geolocalisee_pour_le_moment_:
    "Δεν υπάρχουν δεδομένα γεωγραφικής θέσης αυτή τη στιγμή.",
  envie_d_entrer_dans_la_carte__: "Θέλετε να μπείτε στον χάρτη;",
  chargement_des_logements___: "Φόρτωση περιβλήματος...",
  la_date_d_arriv_e_est_requise: "Απαιτείται ημερομηνία άφιξης",
  la_date_ne_peut_pas__tre_dans_le_pass_:
    "Η ημερομηνία δεν μπορεί να είναι στο παρελθόν",
  la_date_de_d_part_est_requise: "Απαιτείται ημερομηνία αναχώρησης",
  la_date_de_d_part_doit__tre_apr_s_l_arriv_e:
    "Η ημερομηνία αναχώρησης πρέπει να είναι μετά την άφιξη",
  le_message_doit_contenir_au_moins_10_caract_res:
    "Το μήνυμα πρέπει να περιέχει τουλάχιστον 10 χαρακτήρες",
  veuillez_corriger_les_erreurs_ci_dessus: "Διορθώστε τα παραπάνω σφάλματα",
  une_erreur_est_survenue__veuillez_r_essayer_:
    "Παρουσιάστηκε σφάλμα. Δοκιμάστε ξανά.",
  paris__france: "Παρίσι, Γαλλία",
  mode_h_te: "Λειτουργία κεντρικού υπολογιστή",
  je_loue_quelques_semaines_par_an__le_mod_le_1eur___nuit_est_super_simple___expliquer_aux_voyageurs_:
    "Νοικιάζω μερικές εβδομάδες το χρόνο. Το μοντέλο 1 EUR/νύχτα είναι εξαιρετικά απλό να το εξηγήσετε στους ταξιδιώτες.",
  "37_nuits": "37 νύχτες",
  lyon__france: "Λυών, Γαλλία",
  mode_voyageur: "Ταξιδιώτης μόδα",
  la_r_servation_est_fluide__et_surtout_les_frais_sont_lisibles__je_compare_facilement_le_co_t_final_avant_de_confirmer_:
    "Η κράτηση είναι ομαλή και πάνω από όλα οι χρεώσεις είναι ευανάγνωστες. Συγκρίνω εύκολα το τελικό κόστος πριν επιβεβαιώσω.",
  "22_nuits": "22 νύχτες",
  bordeaux__france: "Μπορντό, Γαλλία",
  "54_nuits": "54 νύχτες",
  marseille__france: "Μασσαλία, Γαλλία",
  pro_multi_logements: "Επαγγελματική πολυκατοικία",
  avec_plusieurs_biens__la_version_pro_me_fait_gagner__norm_ment_de_temps_sur_le_calendrier_et_la_gestion_des_demandes_:
    "Με πολλές ιδιότητες, η έκδοση Pro μου εξοικονομεί πολύ χρόνο στον προγραμματισμό και τη διαχείριση αιτημάτων.",
  "9_logements": "9 καταλύματα",
  retours_utilisateurs: "Σχόλια χρηστών",
  des_retours_terrain_concrets: "Ανατροφοδότηση από συγκεκριμένο πεδίο",
  des_voyageurs_et_h_tes_qui_veulent_une_location_plus_claire_et_plus_abordable_:
    "Ταξιδιώτες και οικοδεσπότες που θέλουν μια πιο ξεκάθαρη και πιο οικονομική ενοικίαση.",
  activit_: "δραστηριότητα",
  _conomie_estim_e: "εκτιμώμενη εξοικονόμηση",
  profils_et_logements_v_rifi_s: "Επαληθευμένα προφίλ και καταλύματα",
  exp_rience_location_simplifi_e: "Απλοποιημένη εμπειρία ενοικίασης",
  co_ts_transparents___la_nuit: "Διαφανές κόστος τη νύχτα",
  marquer_des_dates: "Σημειώστε ημερομηνίες",
  je_peux_accueillir: "μπορώ να φιλοξενήσω",
  je_veux_partir: "θέλω να φύγω",
  partir_et_accueillir: "Αναχώρηση και Καλώς ορίσατε",
  accueillir: "Να καλωσορίσω",
  partir: "Αδεια",
  bloquer_les_dates: "Αποκλεισμός ημερομηνιών",
  toujours_partir_et_accueillir: "Πάντα να φεύγεις και να καλωσορίζεις",
  rendre_ce_logement_visible: "Κάντε αυτό το κατάλυμα ορατό",
  rendre_ce_logement_invisible: "Κάντε αυτό το κατάλυμα αόρατο",
  confirmation_visibilite_logement:
    "Είστε βέβαιοι ότι θέλετε να αλλάξετε την ορατότητα αυτής της καταχώρισης για άλλα μέλη;",
  confirmer_activer_toujours_partir_accueillir:
    "Με την ενεργοποίηση αυτής της λειτουργίας, θα προστεθούν νέες διαθεσιμότητες 'Αποχώρηση και Καλωσόρισμα' για να καλύπτουν πάντα τα επόμενα 2 χρόνια από σήμερα. Άλλες μη αυτόματες διαθεσιμότητες θα αντικατασταθούν.\n\nΕίστε βέβαιοι ότι θέλετε να συνεχίσετε;",
  confirmer_desactiver_toujours_partir_accueillir:
    'Είστε βέβαιοι ότι θέλετε να απενεργοποιήσετε τη λειτουργία "Always Leave and Greet";',
  details_de_l_adresse__optionnel_: "Λεπτομέρειες διεύθυνσης (προαιρετικό)",
  rue_et_numero: "Οδός και αριθμός",
  ex__12_rue_de_la_paix: "Π.χ.: 12 rue de la Paix",
  appartement_suite: "Διαμέρισμα, σουίτα κ.λπ.",
  ex__apt_4b: "Π.χ.: Διαμ. 4Β",
  etage: "Πάτωμα",
  ex__3eme_sans_ascenseur: "Π.χ.: 3ο",
  code_d_acces: "Κωδικός πρόσβασης (πόρτα/κτίριο)",
  ex__a1234: "Π.χ.: A1234",
  ces_informations_ne_seront_partagees_qu_avec_les_voyageurs_confirmes:
    "Αυτές οι λεπτομερείς πληροφορίες θα κοινοποιηθούν μόνο σε μέλη που έχουν επιβεβαιωμένη ανταλλαγή μαζί σας.",
  lits_doubles: "Διπλά κρεβάτια",
  lits_simples: "Μονά κρεβάτια",
  canapes_lits: "Καναπέδες-κρεβάτια",
  lits_bebes: "Βρεφικά κρεβάτια",
  amenity_cat_essentials: "Τα απαραίτητα",
  amenity_cat_kitchen: "Μαγείρεμα και γεύματα",
  amenity_cat_bathroom: "Τουαλέτα",
  amenity_cat_bedroom_laundry: "Υπνοδωμάτιο και λευκά είδη",
  amenity_cat_entertainment: "Ψυχαγωγία",
  amenity_cat_family: "Οικογένεια",
  amenity_cat_exterior: "Εκτός",
  amenity_cat_features: "Χαρακτηριστικά",
  amenity_cat_location: "Τοποθεσία",
  amenity_cat_safety: "Ασφάλεια",
  amenity_wifi: "Wi-Fi",
  amenity_workspace: "Ειδικός χώρος εργασίας",
  amenity_ac: "Κλιματισμός",
  amenity_heating: "Θέρμανση",
  amenity_kitchen: "Κουζίνα",
  amenity_refrigerator: "Ψυγείο",
  amenity_microwave: "Φούρνος μικροκυμάτων",
  amenity_oven: "Φούρνος",
  amenity_dishwasher: "Πλυντήριο πιάτων",
  amenity_coffee_maker: "Καφετιέρα",
  amenity_kettle: "Βραστήρας",
  amenity_bathtub: "Μπανιέρα",
  amenity_hair_dryer: "στεγνωτήρας μαλλιών",
  amenity_shampoo: "Σαμπουάν και αφρόλουτρο",
  amenity_hot_water: "Ζεστό νερό",
  amenity_washing_machine: "Πλυντήριο",
  amenity_dryer: "Στεγνωτήριο",
  amenity_iron: "Σίδερο",
  amenity_hangers: "Κρεμάστρες",
  amenity_bed_linens: "Παρέχονται κλινοσκεπάσματα",
  amenity_tv: "Τηλεόραση",
  amenity_game_console: "Κονσόλα παιχνιδιών",
  amenity_books_toys: "Βιβλία και παιχνίδια",
  amenity_sound_system: "Σύστημα ήχου",
  amenity_high_chair: "Παιδικό καρεκλάκι",
  amenity_baby_bath: "Μπάνιο μωρού",
  amenity_travel_cot: "Κούνια ταξιδιού",
  amenity_changing_table: "Τραπέζι αλλαγής",
  amenity_patio: "Μπαλκόνι ή βεράντα",
  amenity_garden: "Ιδιωτικός κήπος",
  amenity_bbq: "Ψησταριά",
  amenity_outdoor_furniture: "Έπιπλα εξωτερικού χώρου",
  amenity_pool: "Πισίνα",
  amenity_hottub: "Τζακούζι",
  amenity_gym: "Γυμναστήριο",
  amenity_fireplace: "Καμινάδα",
  amenity_breakfast: "Περιλαμβάνεται πρωινό",
  amenity_parking: "Δωρεάν στάθμευση",
  amenity_ev_charger: "Σταθμός φόρτισης EV",
  amenity_beachfront: "Πρόσβαση στην παραλία",
  amenity_ski_in_out: "Πρόσβαση στις πίστες του σκι",
  amenity_lake_access: "Πρόσβαση στη λίμνη",
  amenity_smoke_detector: "Ανιχνευτής καπνού",
  amenity_first_aid: "κιτ πρώτων βοηθειών",
  amenity_fire_extinguisher: "Πυροσβεστήρας",
  amenity_sauna: "Σάουνα",
  amenity_massage_chair: "Καρέκλα μασάζ",
  amenity_shower: "Ντους",
  amenity_home_cinema: "Home Cinema",
  amenity_ping_pong: "Τραπέζι πινγκ πονγκ",
  amenity_forest_access: "Πρόσβαση στο δάσος",
  amenity_hiking_access: "Πρόσβαση σε πεζοπορία",
  compl_t_: "ολοκληρώθηκε το",
  l_adresse_doit_tre_localis_e_sur_la_carte:
    "Η διεύθυνση πρέπει να βρίσκεται στο χάρτη",
  au_moins_3_photos_requises: "Απαιτούνται τουλάχιστον 3 φωτογραφίες",
  le_titre_doit_faire_au_moins_10_caract_res:
    "Ο τίτλος πρέπει να αποτελείται από τουλάχιστον 10 χαρακτήρες",
  la_description_doit_faire_au_moins_50_caract:
    "Η περιγραφή πρέπει να αποτελείται από τουλάχιστον 50 χαρακτήρες",
  s_lectionnez_au_moins_3_quipements: "Επιλέξτε τουλάχιστον 3 εξοπλισμό",
  encore_quelques_d_tails_avant_de_publier:
    "Λίγες περισσότερες λεπτομέρειες πριν από τη δημοσίευση",
  votre_annonce_est_compl_t_e_x:
    "Η διαφήμισή σας ολοκληρώθηκε στο {{score}}%. Συμπληρώστε τα στοιχεία που λείπουν για να μπορέσετε να το δημοσιεύσετε:",
  compl_ter: "Πλήρης",
  voici_comment_les_voyageurs_verront_votre_:
    "Έτσι θα βλέπουν οι ταξιδιώτες την καταχώρισή σας.",
  photo: "Φωτογραφία",
  afficher_toutes_les_photos: "Εμφάνιση όλων των φωτογραφιών",
  h_t_par_vous: "• Οικοδεσπότης: Εσείς",
  description: "Σχετικά με αυτό το κατάλυμα",
  votre_description_appara_tra_ici: "Η περιγραφή σας θα εμφανιστεί εδώ...",
  afficher_les_n__quipements_x: "Δείξτε τους{{count}}εξοπλισμός",
  ajouter_une_date: "Προσθέστε μια ημερομηνία",
  aucun_montant_ne_vous_sera_d_bit_:
    "Δεν θα σας χρεωθεί κανένα ποσό αυτήν τη στιγμή",
  demander: "Παρακαλώ",
  enregistrer_et_quitter: "Αποθήκευση και έξοδος",
  enregistrer_pour_plus_tard: "Αποθήκευση για αργότερα",
  conseils_pour_des_photos_r_ussies: "Συμβουλές για επιτυχημένες φωτογραφίες",
  privil_giez_le_format_paysage__1:
    "Επιλέξτε οριζόντια μορφή (16:9) για καλύτερη προβολή.",
  prenez_vos_photos_de_jour__avec_:
    "Τραβήξτε τις φωτογραφίες σας κατά τη διάρκεια της ημέρας, με καλό φυσικό φως.",
  rangez_et_nettoyez_les_pi_ces_av:
    "Αποθηκεύστε και καθαρίστε τα κομμάτια πριν τα φωτογραφίσετε.",
  mettez_en_avant_les_atouts_de_vo:
    "Επισημάνετε τα στοιχεία του καταλύματός σας (θέα, βεράντα, όμορφο σαλόνι κ.λπ.).",
  donnez_un_titre___votre_annonce: "Δώστε στη διαφήμισή σας έναν τίτλο",
  un_titre_court_et_accrocheur_attirera_pl:
    "Ένας σύντομος και πιασάρικος τίτλος θα προσελκύσει περισσότερους ταξιδιώτες.",
  souhaite_visiter: "Θα ήθελα να επισκεφθείτε",
  vous_propose_en_change: "Σας προσφέρει ως αντάλλαγμα",
  autres_logements: "άλλα καταλύματα",
  voir_le_logement: "Δείτε το κατάλυμα",
  votre_demande_titre: "Το αίτημά σας",
  votre_demande_soustitre:
    "Σύνοψη των ταξιδιωτικών σας επιθυμιών και των συντρόφων σας για τις μελλοντικές σας ανταλλαγές.",
  compagnons_de_voyage: "Ταξιδιωτικοί σύντροφοι",
  voyage_avec_bebe: "μωρά)",
  voyage_avec_animaux: "Κατοικίδια",
  disponibilites_souhaitees: "Επιθυμητή διαθεσιμότητα",
  destinations_cibles: "Στοχεύστε προορισμούς",
  aucune_date_precisee: "Δεν έχει καθοριστεί ημερομηνία ταξιδιού.",
  aucune_destination_precisee: "Δεν έχει καθοριστεί προορισμός στόχος.",
  votre_demande_menu: "Το αίτημά σας",
  modifier_mon_profil: "Επεξεργασία του προφίλ μου",
  rayon_de: "Ακτίνα του{{km}}χλμ",
  dates_flexibles_option: "Ευέλικτες ημερομηνίες",
  animaux_de_compagnie_details: "{{count}}ζώο/ζώα",
  changer_d_annonce: "Αλλαγή διαφήμισης",
  profil_du_voyageur: "Προφίλ ταξιδιώτη",
  chambres_requises: "Υποχρεωτικά δωμάτια",
  animaux: "ζώο(α)",
  duree_du_sejour_souhaitee: "Επιθυμητή διάρκεια παραμονής",
  combien_de_chambres_avez_vous_besoin__: "Πόσα υπνοδωμάτια χρειάζεστε;",
  combien_de_b_b_s__: "Πόσα μωρά;",
  combien__: "Πόσο;",
  vos_animaux: "Τα ζώα σας",
  chien_s_: "Σκύλος(οι)",
  plus_de_30_nuits: "Περισσότερες από 30 νύχτες",
  "community.hero.badge": "Η Κοινότητά μας",
  "community.hero.title": "Εγγραφείτε στο πιο αυθεντικό δίκτυο φιλοξενίας",
  "community.hero.subtitle":
    "Μοιραστείτε περισσότερα από το σπίτι σας. Ανακαλύψτε ιστορίες, γνωρίστε παθιασμένους οικοδεσπότες και ταξιδέψτε με αυτοπεποίθηση.",
  "community.stats.members": "Ενεργά Μέλη",
  "community.stats.countries": "Χώρες που αντιπροσωπεύονται",
  "community.stats.exchanges": "Πραγματοποιήθηκαν ανταλλαγές",
  "community.values.title": "Αυτό που μας ενώνει",
  "community.values.trust.title": "Απόλυτη εμπιστοσύνη",
  "community.values.trust.desc":
    "Κάθε μέλος είναι επαληθευμένος οικοδεσπότης, που εγγυάται αμοιβαίο σεβασμό για τις εγκαταστάσεις.",
  "community.values.sharing.title": "Κοινή χρήση & Συναντήσεις",
  "community.values.sharing.desc":
    "Η ευκαιρία να δημιουργήσετε δεσμούς με ντόπιους σε όλη την Ευρώπη.",
  "community.values.savings.title": "Πραγματική Αποταμίευση",
  "community.values.savings.desc":
    "Ταξιδεύετε πιο συχνά, παραπέρα, διατηρώντας παράλληλα τον προϋπολογισμό σας.",
  "community.testimonials.title": "Ιστορίες μελών",
  "community.cta.title": "Είστε έτοιμοι να γίνετε μέρος της περιπέτειας;",
  "community.cta.button": "Γίνετε μέλος σήμερα",
  "blog.hero.badge": "Το Blog μας",
  "blog.hero.title": "Έμπνευση & Συμβουλές",
  "blog.hero.subtitle":
    "Ανακαλύψτε ταξιδιωτικές ιστορίες, συμβουλές για την προετοιμασία της διαμονής σας και τι νέο υπάρχει στο κλαμπ.",
  "blog.categories.all": "Όλα τα άρθρα",
  "blog.categories.tips": "Συμβουλές οικοδεσπότη",
  "blog.categories.inspiration": "Ταξιδιωτική έμπνευση",
  "blog.categories.news": "Νέα",
  "blog.empty": "Δεν υπάρχουν άρθρα αυτή τη στιγμή. Επιστρέψτε σύντομα!",
  "help.hero.badge": "Κέντρο βοήθειας",
  "help.hero.title": "Πώς μπορούμε να σας βοηθήσουμε;",
  "help.hero.subtitle":
    "Βρείτε γρήγορες απαντήσεις ή επικοινωνήστε με την ομάδα υποστήριξής μας.",
  "help.search.placeholder": "Ψάξε για απάντηση...",
  "help.categories.account.title": "Λογαριασμός & Προφίλ",
  "help.categories.account.desc":
    "Διαχειριστείτε τις πληροφορίες, τους κωδικούς πρόσβασης και τις προτιμήσεις σας.",
  "help.categories.exchanges.title": "Ανταλλαγές & Κρατήσεις",
  "help.categories.exchanges.desc":
    "Πώς να προσφέρετε, να αποδεχτείτε ή να ακυρώσετε μια ανταλλαγή.",
  "help.categories.trust.title": "Εμπιστοσύνη & Ασφάλεια",
  "help.categories.trust.desc":
    "Συμβάσεις, έλεγχος και προστασία της κατοικίας.",
  "help.faq.title": "Συχνές Ερωτήσεις",
  "help.contact.cta": "Δεν βρήκατε την απάντησή σας;",
  "help.contact.button": "Επικοινωνήστε μαζί μας",
  "careers.hero.badge": "Εγγραφείτε στην ομάδα",
  "careers.hero.title": "Ας χτίσουμε το μέλλον των ταξιδιών",
  "careers.hero.subtitle":
    "Αναζητούμε παθιασμένους ανθρώπους για να επαναπροσδιορίσουμε τον τρόπο με τον οποίο ταξιδεύουν οι επισκέπτες στην Ευρώπη.",
  "careers.values.title": "Οι αξίες μας",
  "careers.values.trust.title": "Άνθρωπος και εμπιστοσύνη",
  "careers.values.remote.title": "Ευέλικτη τηλεργασία",
  "careers.values.impact.title": "Πραγματικός αντίκτυπος",
  "careers.openings.title": "Ανοιχτές θέσεις",
  "careers.openings.empty":
    "Δεν υπάρχουν ανοιχτές θέσεις αυτήν τη στιγμή. Μη διστάσετε να στείλετε μια αυθόρμητη αίτηση!",
  "careers.apply.title": "Αυθόρμητη Εφαρμογή",
  "careers.apply.desc":
    "Στείλτε το βιογραφικό σας και πείτε μας πώς μπορείτε να βοηθήσετε το Donkey Travel.",
  "careers.apply.button": "Στείλε την αίτησή μου",
  "contact.hero.badge": "Επαφή",
  "contact.hero.title": "Είμαστε εδώ για εσάς",
  "contact.hero.subtitle":
    "Μια ερώτηση, πρόταση ή πρόβλημα; Η ομάδα μας είναι έτοιμη να σας ακούσει.",
  "contact.form.name": "Το όνομά σου",
  "contact.form.email": "Το email σας",
  "contact.form.subject": "Θέμα του μηνύματός σας",
  "contact.form.message": "Το μήνυμά σας...",
  "contact.form.send": "Αποστολή μηνύματος",
  "contact.info.title": "Χρήσιμες Πληροφορίες",
  "contact.info.email": "contact@donkey.travel",
  "contact.info.address": "Κοιλάδα Haute-Somme, Picardy, Γαλλία",
  "contact.info.hours": "Δευτ. - Παρ: 9:00 π.μ. - 6:00 μ.μ.",
  activez_votre_abonnement: "Ενεργοποιήστε τη συνδρομή σας",
  finalisez_votre_inscription: "Ολοκληρώστε την εγγραφή σας",
  _changes_illimit_s_en_europe: "Απεριόριστες ανταλλαγές στην Ευρώπη",
  validit___1_an: "Ισχύς: 1 έτος",
  paiement_100__s_curis__par_paypal: "100% ασφαλής πληρωμή μέσω PayPal",
  me_d_connecter_et_revenir_plus_tard: "Αποσυνδεθείτε και επιστρέψτε αργότερα",
  erreur_lors_de_la_validation_du_paiement_sur_n:
    "Σφάλμα κατά την επικύρωση της πληρωμής στους διακομιστές μας.",
  le_paiement_n_a_pas_pu__tre_valid_:
    "Δεν ήταν δυνατή η επικύρωση της πληρωμής.",
  une_erreur_inconnue_est_survenue_lors_du_paiem:
    "Παρουσιάστηκε άγνωστο σφάλμα κατά την πληρωμή.",
  impossible_d_initialiser_paypal__v_rifiez_vot:
    "Δεν είναι δυνατή η προετοιμασία του PayPal. Ελέγξτε τη σύνδεσή σας.",
  donn_es_personnelles: "Προσωπική πληροφορία",
  rejoignez_notre_communaut__et_r_servez_un_logement:
    "Εγγραφείτε στην κοινότητά μας και κάντε κράτηση για καταλύματα στην {{πόλη}} με σαφείς σταθερές χρεώσεις και ασφάλιση.",
  bienvenue: "Καλωσόρισμα",
  code_promo_applique_avec_succes:
    "Ο κωδικός προσφοράς εφαρμόστηκε με επιτυχία!",
  cible: "Στόχος",
  propose: "Προτείνω",
  "1_sens": "1 αίσθηση",
  "2_sens": "2 αισθήσεις",
  ils_veulent_visiter_votre_region_br_c_est_a_vous:
    "Θέλουν να επισκεφτούν την περιοχή σας.<br />Εναπόκειται σε εσάς να μάθετε πού μένουν!",
  ils_cherchent_chez_vous_et_br_ils_habitent_la_ou:
    "Σε ψάχνουν ΚΑΙ<br />ζουν εκεί που θέλεις να πας!",
  comment_ca_marche: "Πώς λειτουργεί;",
  comprendre_les_differents_types_de_matching:
    "Κατανόηση των διαφορετικών τύπων αντιστοίχισης",
  match_reciproque: "Ανταπόκριση",
  details_de_la_demande: "Ζητήστε λεπτομέρειες",
  souhaite_venir_dans_votre_secteur: "Θα θέλατε να έρθετε στην περιοχή σας:",
  peut_vous_accueillir: "Μπορεί να σας φιλοξενήσει:",
  souhaite_visiter_dans_un_rayon:
    "Αν θέλετε να επισκεφτείτε την <strong>{{πόλη}}</strong> σε ακτίνα <strong>{{ακτίνας}} χλμ.</strong>, το κατάλυμά σας αντιστοιχεί στην αναζήτησή τους.",
  souhaite_visiter_ville:
    "Αν θέλετε να επισκεφτείτε την <strong>{{πόλη}}</strong>, το κατάλυμα σας ταιριάζει με την αναζήτησή τους.",
  a_besoin_de_chambres: "Χρειάζεται {{count}} δωμάτια.",
  comparateur_de_valeur: "Συγκριτής αξίας",
  ecart: "χάσμα",
  code_promo_invalide: "Μη έγκυρος κωδικός προσφοράς",
  erreur_verification_code: "Σφάλμα κατά την επαλήθευση του κωδικού",
  vous_avez_un_code_promo: "Έχετε κωδικό προσφοράς;",
  entrez_votre_code: "ΕΙΣΑΓΑΓΕΤΕ ΤΟΝ ΚΩΔΙΚΟ ΣΑΣ",
  appliquer: "Εφαρμογή",
  importation_r_ussie_:
    "Επιτυχής εισαγωγή! Τα στοιχεία σας έχουν προσυμπληρωθεί.",
  erreur_lors_de_l_importation: "Σφάλμα κατά την εισαγωγή:",
  d_crivez_ce_qui_rend_votre_logement_uniq:
    "Περιγράψτε τι κάνει το σπίτι σας μοναδικό...",
  mettez_en_avant_les_points_forts___votre:
    "Επισημάνετε τα δυνατά σημεία του καταλύματός σας",
  lien_annonce_airbnb_1: "Σύνδεσμος στην καταχώρισή σας στην Airbnb",
  importation___: "Εισαγωγή...",
  importer_l_annonce: "Εισαγωγή διαφήμισης",
  renseignez_le_lien_de_votre_annonce_pou_:
    "Εισαγάγετε τον σύνδεσμο προς τη διαφήμισή σας. Μπορείτε να εισαγάγετε τις λεπτομέρειες αυτόματα για εξοικονόμηση χρόνου.",
  lien_calendrier_airbnb: "Σύνδεσμος ημερολογίου (iCal)",
  nous_utiliserons_ce_lien_pour_synchroni:
    "Θα χρησιμοποιήσουμε αυτόν τον σύνδεσμο για να συγχρονίσουμε τη διαθεσιμότητά σας.",
  entrer_en_contact: "Ελάτε σε επαφή",
  attention___risque__lev__de_d_pendance_aux_voyages_gratuits__:
    "Προειδοποίηση: υψηλός κίνδυνος εθισμού στα δωρεάν ταξίδια!",
};
